<template>
    <div class="settlement_container">
        <!-- 搜索区域 -->
        <global-tag>
            <span slot="title">信息</span>
            <div class="search" slot="search">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="姓名：">
                                <el-input
                                    v-model="customerName"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="性别：">
                                <el-select
                                    v-model="gender"
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option
                                        :value="0"
                                        label="男"
                                    ></el-option>
                                    <el-option
                                        :value="1"
                                        label="女"
                                    ></el-option>
                                </el-select>
                                <!-- <el-select
                    v-model="gender"
                    placeholder="请选择"
                    style="width: 100%"
                >
                  <el-option
                      v-for="item in genderOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="审核状态：">
                                <el-select
                                    v-model="tableApprovalStatus"
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option
                                        label="全部"
                                        value=""
                                    ></el-option>
                                    <el-option
                                        label="未分配"
                                        value="0"
                                    ></el-option>
                                    <el-option
                                        label="待评估"
                                        value="1"
                                    ></el-option>
                                    <el-option
                                        label="app评估放弃"
                                        value="10"
                                    ></el-option>
                                    <el-option
                                        label="app评估完成"
                                        value="9"
                                    ></el-option>
                                    <el-option
                                        label="评估审核通过"
                                        value="2"
                                    ></el-option>
                                    <el-option
                                        label="评估审核未通过"
                                        value="3"
                                    ></el-option>
                                    <el-option
                                        label="app施工放弃"
                                        value="12"
                                    ></el-option>
                                    <el-option
                                        label="app施工完成"
                                        value="11"
                                    ></el-option>
                                    <el-option
                                        label="施工督查通过"
                                        value="4"
                                    ></el-option>
                                    <el-option
                                        label="施工督查未通过"
                                        value="5"
                                    ></el-option>
                                    <el-option
                                        label="待回访"
                                        value="6"
                                    ></el-option>
                                    <el-option
                                        label="回访完成"
                                        value="7"
                                    ></el-option>
                                    <el-option
                                        label="完工"
                                        value="8"
                                    ></el-option>
                                    <!-- <el-option
                    v-for="(item, key, index) in approvalStatusList"
                    :key="index"
                    :label="item"
                    :value="key"
                  >
                  </el-option> -->
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="项目名称：">
                                <el-select
                                    v-model="projectId"
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(
                                            item, index
                                        ) in projectManageList"
                                        :key="index"
                                        :label="item.projectName"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="服务商：">
                                <el-select
                                    v-model="serviceProviderId"
                                    placeholder="请选择"
                                    style="width: 100%"
                                    @change="providerChange1"
                                >
                                    <el-option
                                        v-for="(item, index) in providerList"
                                        :key="index"
                                        :label="item.constructUnit"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="服务人员：">
                                <el-select
                                    v-model="serviceProviderPersonId"
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(
                                            item, index
                                        ) in providerPersonList1"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="5" :offset="1">
              <el-form-item label="身份证号：">
                <el-input v-model="idCard" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col> -->
                        <el-col :span="3" :offset="5">
                            <el-button
                                type="primary"
                                class="searchBtns"
                                @click="querySearch"
                                >搜索
                            </el-button>
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                type="info"
                                class="resetReach"
                                @click="handleEmpty"
                                >清除条件
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group" style="margin: 15px 0">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        class="openBtns"
                        @click="handleTableForm('新增', 0)"
                        >新增
                    </el-button>
                    <el-button type="primary" @click="getEvaluateType"
                        >评价内容设置
                    </el-button>
                    <el-popover
                        placement="top-start"
                        width="200"
                        trigger="click"
                    >
                        <slot>
                            <vue-qr
                                text="https://www.baidu.com/"
                                :size="200"
                            ></vue-qr>
                        </slot>
                        <el-button
                            type="primary"
                            slot="reference"
                            class="reference"
                            >生成申请二维码
                        </el-button>
                        <!-- <img slot="reference" src="../assets/img/table_sc.png" style="width: 19px;margin-left: 12px;cursor: pointer"  @click="createCode(scope.row)"/> -->
                    </el-popover>
                    <!-- <el-button type="primary">生成申请二维码</el-button> -->

                    <el-button
                        type="info"
                        @click="handleExcel"
                        icon="el-icon-download"
                        class="button downOutBtns"
                        >导出全部Excel
                    </el-button>
                    <el-button type="danger" @click="batchFenpei">
                        批量分配</el-button
                    >
                    <el-button
                        icon="el-icon-edit"
                        type="info"
                        @click="batchClear"
                        >清除号码</el-button
                    >
                </el-button-group>
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group style="display: flex">
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="Reset1"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="姓名"></el-checkbox>
                                    <br />
                                    <el-checkbox label="性别"></el-checkbox>
                                    <br />
                                    <el-checkbox label="联系方式"></el-checkbox>
                                    <br />
                                    <el-checkbox label="身份证号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="年龄"></el-checkbox>
                                    <br />
                                    <el-checkbox label="老人类型"></el-checkbox>
                                    <br />
                                    <el-checkbox label="居住地址"></el-checkbox>
                                    <br />
                                    <el-checkbox label="创建人"></el-checkbox>
                                    <br />
                                    <el-checkbox label="审核状态"></el-checkbox>
                                    <br />
                                    <el-checkbox label="操作"></el-checkbox>
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- 页面表格 -->
        <div class="table_container" style="margin-top: 10px">
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                @selection-change="handleSelectionChange"
                border
            >
                <el-table-column
                    type="selection"
                    width="50"
                    align="center"
                    @selection-change="handleSelectionChange"
                >
                </el-table-column>
                <el-table-column
                    width="60px"
                    align="center"
                    label="序号"
                    type="index"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '序号'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    min-width="100px"
                    label="姓名"
                    prop="customerName"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '姓名'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    min-width="70px"
                    align="center"
                    label="性别"
                    prop="gender"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '性别'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.gender == '0'">男</span>
                        <span v-if="scope.row.gender == '1'">女</span>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120px"
                    align="center"
                    label="联系方式"
                    prop="phone"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '联系方式'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    min-width="150px"
                    align="center"
                    label="身份证号"
                    prop="idCard"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '身份证号'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    min-width="70px"
                    align="center"
                    label="年龄"
                    prop="age"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '年龄'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    min-width="100px"
                    align="center"
                    label="老人类型"
                    prop="elderlyBelongCategory"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '老人类型'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-for="(item, index) in oldtypeLits" :key="index"
                            ><span
                                v-if="
                                    scope.row.elderlyBelongCategory ==
                                    item.dictCode
                                "
                                >{{ item.dictLabel }}</span
                            ></span
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="150px"
                    align="center"
                    label="居住地址"
                    prop="address"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '居住地址'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    min-width="100px"
                    align="center"
                    label="审核状态"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '审核状态'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        {{
                            approvalStatusList[scope.row.approvalStatus]
                                ? approvalStatusList[scope.row.approvalStatus]
                                : "暂无状态"
                        }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="创建人"
                    prop="createPersonName"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '创建人'
                        ) !== -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>

                <!-- width="500" -->
                <el-table-column
                    min-width="150px"
                    align="center"
                    label="操作"
                    fixed="right"
                    v-if="
                        tempTableChekbox.findIndex(
                            (item) => item === '操作'
                        ) !== -1
                    "
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleTableForm('查看', 1, scope.row)"
                            >查看</el-button
                        >
                        <el-button
                            type="text"
                            @click="handleTableForm('编辑', 1, scope.row)"
                            >编辑</el-button
                        >
                        <el-button
                            type="text"
                            v-if="
                                scope.row.approvalStatus == 1 &&
                                scope.row.saveStatus != 1
                            "
                            @click="handleTableReturn(scope.row)"
                            >撤回
                        </el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.distributeButtonFlag == 1"
                            @click="handleTableForm('分配', 2, scope.row)"
                            >分配
                        </el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.assessButtonFlag == 1"
                            @click="handleTableForm('评估审核', 3, scope.row)"
                            >评估审核
                        </el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.printButtonFlag == 1"
                            @click="showPrintDialog(scope.row)"
                            >打印
                        </el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.constructionButtonFlag == 1"
                            @click="handleTableForm('施工督查', 4, scope.row)"
                            >施工督查
                        </el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.evaluateButtonFlag == 1"
                            @click="handleTableForm('评价', 5, scope.row)"
                            >评价
                        </el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.returnVisitButtonFlag == 1"
                            @click="handleTableForm('回访工单', 6, scope.row)"
                            >回访工单
                        </el-button>
                        <el-button
                            type="text"
                            v-if="scope.row.finishedButtonFlag == 1"
                            @click="handleTableForm('完工', 7, scope.row)"
                            >完工
                        </el-button>
                        <el-button
                            type="text"
                            @click="handleTableDelet(scope.row)"
                            >删除</el-button
                        >
                        <!--
            <span slot="icon" @click="handleTableForm('验收审核', 5, scope.row)"
              >验收审核</span
            >-->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <!-- <el-pagination
        layout='total, sizes, prev, pager, next, jumper'
        background
        :page-size='tableDataPageSize'
        :total='tableDataCount'
        :current-page.sync='tableDataPageNo'
        @size-change='handletableDataSize'
        @current-change='handleTableDataChange'
      ></el-pagination> -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 40, 100]"
                :page-size="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
            <!--  -->
        </div>
        <!--评价内容弹窗-->
        <el-dialog
            title="评价内容设置"
            :visible.sync="addDialog"
            width="40%"
            class="dialog_container"
            @close="addDialogClose"
        >
            <div class="dialog_content">
                <el-button
                    type="success"
                    icon="iconfont icon-xinzeng"
                    @click="handleAddDialogData('新增')"
                    style="margin-bottom: 12px"
                    >新增
                </el-button>
                <el-table
                    :data="addDialogData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
                    border
                >
                    <el-table-column
                        type="index"
                        width="70"
                        prop="id"
                        label="序号"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="typeName"
                        label="类型"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <!--<el-table-column
            align="center"
            prop="problem"
            label="问题"
            :show-overflow-tooltip="true"
          ></el-table-column>-->
                    <el-table-column label="操作" align="center" width="140px">
                        <template slot-scope="scope">
                            <el-tooltip
                                effect="dark"
                                content="编辑"
                                placement="top-start"
                            >
                                <img
                                    src="../assets/img/table_edit.png"
                                    @click="
                                        handleAddDialogData('编辑', scope.row)
                                    "
                                />
                            </el-tooltip>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="删除"
                                placement="top-start"
                            >
                                <img
                                    src="../assets/img/table_delete.png"
                                    @click="
                                        handleAddDialogData('删除', scope.row)
                                    "
                                    style="margin-left: 12px; cursor: pointer"
                                />
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <!--
        <div class="pagination_container">
          <el-pagination
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="6"
          ></el-pagination>
        </div>-->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addDialog = false"
                    >确 定</el-button
                >
                <el-button @click="addDialog = false">取 消</el-button>
            </span>
        </el-dialog>
        <!--评价内容新增弹窗-->
        <el-dialog
            title="评价内容设置"
            :visible.sync="setUpDialog"
            width="40%"
            class="dialog_container"
            @close="setUpDialogClose"
        >
            <div class="dialog_content">
                <el-form
                    ref="setUpDialogForm"
                    :model="setUpDialogForm"
                    label-width="120px"
                >
                    <el-form-item label="类型：">
                        <el-input v-model="setUpDialogForm.typeName"></el-input>
                    </el-form-item>
                    <el-form-item label="发布类型：">
                        <el-radio-group
                            v-model="setUpDialogForm.publishPlatform"
                        >
                            <el-radio label="0">APP</el-radio>
                            <el-radio label="1">WEB</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="所属机构:" prop="dataId">
                        <el-input
                            v-if="setUpDialogForm.dataName"
                            v-model="setUpDialogForm.dataName"
                            disabled
                        ></el-input>
                        <el-cascader
                            :options="ssorgList"
                            v-model="setUpDialogForm.dataId"
                            style="width: 80%"
                            ref="tree"
                            :props="{
                                checkStrictly: true,
                                emitPath: false,
                                label: 'label',
                                value: 'orgId',
                            }"
                            v-else
                        ></el-cascader>
                    </el-form-item>
                    <div class="fixed" @click="handelAddProblem">
                        <el-button
                            size="mini"
                            type="primary"
                            icon="el-icon-plus"
                            >问题
                        </el-button>
                    </div>
                    <template>
                        <template v-for="(item, index) in addProblemList">
                            <div :key="index">
                                <el-form-item label="问题：">
                                    <el-input
                                        v-model="
                                            addProblemList[index].questionName
                                        "
                                        placeholder="请输入问题"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="回复选择：">
                                    <el-radio-group
                                        v-model="
                                            addProblemList[index].replySelection
                                        "
                                    >
                                        <el-radio :label="0">是</el-radio>
                                        <el-radio :label="1">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item
                                    label="原因："
                                    placeholder="请输入内容"
                                    v-show="
                                        addProblemList[index].replySelection ==
                                        1
                                    "
                                >
                                    <el-input
                                        type="textarea"
                                        :rows="3"
                                        v-model="addProblemList[index].reason"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </template>
                    </template>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addEvaluateType"
                    >确 定</el-button
                >
                <el-button @click="setUpDialog = false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 老人编辑弹窗 -->
        <el-dialog
            title="编辑"
            :visible.sync="setUpDialogDeit"
            width="70%"
            class="dialog_container"
            @close="editCancel"
        >
            <div class="dialog_content">
                <!--新增查看表单-->
                <div
                    class="dialog_content_pane"
                    v-show="stepIndex == 0 || stepIndex == 1"
                >
                    <el-form
                        label-width="120px"
                        :model="formDataEdit"
                        :rules="formDataRules"
                        ref="formData"
                    >
                        <el-row>
                            <el-col :span="24">
                                <el-row
                                    style="
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 20px;
                                    "
                                >
                                    <el-col :span="19">
                                        <el-row class="dialog_form_left">
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="姓名："
                                                    prop="name"
                                                >
                                                    <el-select
                                                        v-model="
                                                            formDataEdit.oldId
                                                        "
                                                        filterable
                                                        remote
                                                        style="width: 100%"
                                                        placeholder="请输入关键词"
                                                        disabled
                                                        :remote-method="
                                                            remoteMethod
                                                        "
                                                        @change="handleSelect"
                                                        @click.native="
                                                            clearForm
                                                        "
                                                        :loading="loading"
                                                    >
                                                        <el-option
                                                            v-for="item in options"
                                                            :key="item.id"
                                                            :label="
                                                                item.customerName
                                                            "
                                                            :value="item.id"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11" :offset="1">
                                                <el-form-item
                                                    label="身份证号："
                                                    prop="idCard"
                                                >
                                                    <el-input
                                                        v-model.trim="
                                                            formDataEdit.idCard
                                                        "
                                                        disabled
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="联系方式："
                                                    prop="phone"
                                                >
                                                    <el-input
                                                        v-model.trim="
                                                            formDataEdit.phone
                                                        "
                                                        disabled
                                                        @blur="checkMobile"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="11" :offset="1">
                                                <el-form-item label="性别：">
                                                    <el-radio-group
                                                        v-model="
                                                            formDataEdit.gender
                                                        "
                                                        disabled
                                                    >
                                                        <el-radio label="0"
                                                            >男</el-radio
                                                        >
                                                        <el-radio label="1"
                                                            >女</el-radio
                                                        >
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-form-item label="座机号：">
                                                    <el-input
                                                        v-model.trim="
                                                            formDataEdit.familyCall
                                                        "
                                                        disabled
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="年龄："
                                                    :offset="1"
                                                >
                                                    <el-input
                                                        v-model.trim="
                                                            formDataEdit.age
                                                        "
                                                        disabled
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="老人类别："
                                                    required
                                                >
                                                    <el-select
                                                        style="100%"
                                                        v-model="
                                                            formDataEdit.elderlyBelongCategory
                                                        "
                                                        disabled
                                                        placeholder="请选择老人类别"
                                                    >
                                                        <el-option
                                                            v-for="(
                                                                item, index
                                                            ) in oldtypeLits"
                                                            :key="index"
                                                            :label="
                                                                item.dictLabel
                                                            "
                                                            :value="
                                                                item.dictCode
                                                            "
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col
                                        :span="5"
                                        style="
                                            display: flex;
                                            flex-direction: column;
                                            align-items: center;
                                            margin-top: -28px;
                                        "
                                    >
                                        <!-- class="avatar-uploader" -->
                                        <el-upload
                                            :action="baseUrl"
                                            :show-file-list="false"
                                            disabled
                                            :on-success="
                                                (file, fileList) => {
                                                    handleAvatarSuccess(
                                                        file,
                                                        fileList,
                                                        'add'
                                                    )
                                                }
                                            "
                                            :before-upload="beforeAvatarUpload"
                                            accept=".jpg,.png"
                                        >
                                            <div class="avatar" v-if="imageUrl">
                                                <img :src="imageUrl" />
                                            </div>
                                            <div v-else>
                                                <div
                                                    class="avatar"
                                                    v-if="
                                                        dialogVisibleTitle ==
                                                        '查看'
                                                    "
                                                >
                                                    <img
                                                        src="../assets/img/user.png"
                                                    />
                                                </div>
                                                <i
                                                    class="
                                                        el-icon-plus
                                                        avatar_uploader
                                                        avatar-uploader-icon
                                                    "
                                                    v-else
                                                ></i>
                                            </div>
                                        </el-upload>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-form-item label="居住地地址" required>
                            <el-row>
                                <el-col :span="4">
                                    <el-form-item prop="provinceId">
                                        <el-select
                                            v-model="formDataEdit.provinceId"
                                            placeholder="请选择省"
                                            @change="handleProvince"
                                            disabled
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in provinceList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-form-item prop="cityId">
                                        <el-select
                                            disabled
                                            v-model="formDataEdit.cityId"
                                            placeholder="请选择市"
                                            @change="handleCity"
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in cityList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-form-item prop="areaId">
                                        <el-select
                                            disabled
                                            v-model="formDataEdit.areaId"
                                            placeholder="请选择区"
                                            @change="handleArea"
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in areaList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-form-item prop="streetId">
                                        <el-select
                                            disabled
                                            v-model="formDataEdit.streetId"
                                            placeholder="请选择街道"
                                            @change="streetChange"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in streetList"
                                                :key="index"
                                                :label="item.addName"
                                                :value="item.addCode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-form-item prop="communityId">
                                        <el-select
                                            disabled
                                            v-model="formDataEdit.communityId"
                                            placeholder="请选择社区"
                                        >
                                            <el-option
                                                v-for="item in communityList"
                                                :key="item.id"
                                                :label="item.address"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item prop="address">
                                <input
                                    v-model="formDataEdit.address"
                                    id="tipinput2"
                                    class="el-input__inner"
                                    :class="
                                        dialogVisibleTitle == '查看' ||
                                        currentStepIndex > 1
                                            ? 'is-disabled'
                                            : ''
                                    "
                                    disabled
                                    @focus="getMap1('tipinput2')"
                                    style="margin-top: 12px"
                                    placeholder="请输入关键字"
                                    autocomplete="off"
                                />
                            </el-form-item>
                            <div class="map_container">
                                <div
                                    class="map_right"
                                    id="container2"
                                    style="
                                        width: 100%;
                                        height: 300px;
                                        margin-top: 15px;
                                    "
                                ></div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editRoomlist"
                    >确 定</el-button
                >
                <el-button @click="editCancel">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 表格表单弹窗 -->
        <el-dialog
            :title="dialogVisibleTitle"
            :visible.sync="dialogVisible"
            width="70%"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-steps
                    :active="stepIndex"
                    align-center
                    v-show="stepIndex != 0"
                >
                    <el-step
                        @click.native="handleStep(1)"
                        v-if="isStepsfzc != 1"
                        ><span slot="icon">基本信息</span></el-step
                    >
                    <el-step @click.native="handleStep(2)"
                        ><span slot="icon">分配信息</span></el-step
                    >
                    <el-step
                        @click.native="handleStep(3)"
                        v-if="isSteps >= 2 && currentRow.approvalStatus != 1"
                        ><span slot="icon">评估审核</span></el-step
                    >
                    <el-step
                        @click.native="handleStep(4)"
                        v-if="isSteps >= 5 && currentRow.approvalStatus != 1"
                        ><span slot="icon">施工督查</span></el-step
                    >
                    <!-- <el-step  style="display:none;"><span slot="icon">验收审核</span></el-step> -->
                    <el-step
                        @click.native="handleStep(5)"
                        v-if="isSteps >= 7 && currentRow.approvalStatus != 1"
                        ><span slot="icon">评价</span></el-step
                    >
                    <el-step
                        @click.native="handleStep(6)"
                        v-if="
                            isSteps >= 8 &&
                            currentRow.approvalStatus != 1 &&
                            currentRow.publishPlatform == 1
                        "
                        ><span slot="icon">回访工单</span></el-step
                    >
                    <el-step
                        @click.native="handleStep(7)"
                        v-if="isSteps >= 9 && currentRow.approvalStatus != 1"
                        ><span slot="icon">完工</span></el-step
                    >
                </el-steps>
                <!--新增查看表单-->
                <div
                    class="dialog_content_pane"
                    v-show="stepIndex == 0 || stepIndex == 1"
                >
                    <el-form
                        label-width="110px"
                        :model="formData"
                        :rules="formDataRules"
                        ref="formData"
                        :disabled="
                            dialogVisibleTitle == '查看' || currentStepIndex > 1
                        "
                    >
                        <el-row>
                            <el-col :span="24">
                                <el-row
                                    style="
                                        display: flex;
                                        align-items: center;
                                        margin-bottom: 20px;
                                    "
                                >
                                    <el-col :span="19">
                                        <el-row class="dialog_form_left">
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="姓名："
                                                    prop="oldId"
                                                >
                                                    <el-select
                                                        v-model="formData.oldId"
                                                        filterable
                                                        remote
                                                        style="width: 100%"
                                                        placeholder="请输入关键词"
                                                        :disabled="
                                                            dialogVisibleTitle ==
                                                                '查看' ||
                                                            dialogVisibleTitle ==
                                                                '编辑'
                                                        "
                                                        :remote-method="
                                                            remoteMethod
                                                        "
                                                        @change="handleSelect"
                                                        @click.native="
                                                            clearForm
                                                        "
                                                        :loading="loading"
                                                    >
                                                        <el-option
                                                            v-for="item in options"
                                                            :key="item.id"
                                                            :label="
                                                                item.customerName
                                                            "
                                                            :value="item.id"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11" :offset="1">
                                                <el-form-item
                                                    label="身份证号："
                                                    prop="idCard"
                                                >
                                                    <el-select
                                                        v-model="
                                                            formData.idCard
                                                        "
                                                        filterable
                                                        remote
                                                        style="width: 100%"
                                                        placeholder="请输入关键词"
                                                        :disabled="
                                                            dialogVisibleTitle ===
                                                                '查看' ||
                                                            dialogVisibleTitle ===
                                                                '编辑'
                                                        "
                                                        :remote-method="
                                                            remoteMethod1
                                                        "
                                                        @change="handleSelect"
                                                        @click.native="
                                                            clearForm1
                                                        "
                                                        :loading="loading"
                                                    >
                                                        <el-option
                                                            v-for="item in options"
                                                            :key="item.id"
                                                            :label="item.idCard"
                                                            :value="item.id"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="联系方式："
                                                    prop="phone"
                                                >
                                                    <el-input
                                                        v-model.trim="
                                                            formData.phone
                                                        "
                                                        disabled
                                                        placeholder="请输入"
                                                        @blur="checkMobile"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>

                                            <el-col :span="11" :offset="1">
                                                <el-form-item label="性别：">
                                                    <el-radio-group
                                                        v-model="
                                                            formData.gender
                                                        "
                                                        disabled
                                                    >
                                                        <el-radio label="0"
                                                            >男</el-radio
                                                        >
                                                        <el-radio label="1"
                                                            >女</el-radio
                                                        >
                                                    </el-radio-group>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11">
                                                <el-form-item label="座机号：">
                                                    <el-input
                                                        v-model.trim="
                                                            formDataEdit.familyCall
                                                        "
                                                        disabled
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="11" :offset="1">
                                                <el-form-item label="年龄：">
                                                    <el-input
                                                        v-model.trim="
                                                            formData.age
                                                        "
                                                        disabled
                                                        placeholder="请输入"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-col :span="11">
                                                <el-form-item
                                                    label="老人类别："
                                                    required
                                                >
                                                    <el-select
                                                        style="100%;display:block"
                                                        v-model="
                                                            formData.elderlyBelongCategory
                                                        "
                                                        placeholder="请输入"
                                                        disabled
                                                    >
                                                        <el-option
                                                            v-for="(
                                                                item, index
                                                            ) in oldtypeLits"
                                                            :key="index"
                                                            :label="
                                                                item.dictLabel
                                                            "
                                                            :value="
                                                                item.dictCode
                                                            "
                                                        ></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col
                                        :span="5"
                                        style="
                                            display: flex;
                                            flex-direction: column;
                                            text-align: center;
                                            margin-top: -28px;
                                        "
                                    >
                                        <!-- class="avatar-uploader" -->
                                        <el-upload
                                            :action="baseUrl"
                                            :show-file-list="false"
                                            :on-success="
                                                (file, fileList) => {
                                                    handleAvatarSuccess(
                                                        file,
                                                        fileList,
                                                        'add'
                                                    )
                                                }
                                            "
                                            :before-upload="beforeAvatarUpload"
                                            accept=".jpg,.png"
                                        >
                                            <div class="avatar" v-if="imageUrl">
                                                <img :src="formData.photo" />
                                            </div>
                                            <div v-else>
                                                <div
                                                    class="avatar"
                                                    v-if="
                                                        dialogVisibleTitle ==
                                                        '查看'
                                                    "
                                                >
                                                    <img
                                                        src="../assets/img/user.png"
                                                    />
                                                </div>
                                                <i
                                                    class="
                                                        el-icon-plus
                                                        avatar_uploader
                                                        avatar-uploader-icon
                                                    "
                                                    v-else
                                                ></i>
                                            </div>
                                        </el-upload>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-form-item
                            label="居住地地址："
                            required
                            label-width="110px"
                        >
                            <el-row>
                                <el-col :span="4">
                                    <el-form-item prop="provinceId">
                                        <el-select
                                            v-model="formData.provinceId"
                                            placeholder="请选择省"
                                            @change="handleProvince"
                                            disabled
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="(
                                                    item, index
                                                ) in provinceList"
                                                :key="index"
                                                :label="item.name"
                                                :value="item.adcode"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.cityId"
                                        disabled
                                        placeholder="请选择市"
                                        @change="handleCity"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(item, index) in cityList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.areaId"
                                        disabled
                                        placeholder="请选择区"
                                        @change="handleArea"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="(item, index) in areaList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        v-model="formData.streetId"
                                        disabled
                                        placeholder="请选择街道"
                                        @change="streetChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in streetList"
                                            :key="index"
                                            :label="item.addName"
                                            :value="item.addCode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4" :offset="1">
                                    <el-select
                                        disabled
                                        v-model="formData.communityId"
                                        placeholder="请选择社区"
                                    >
                                        <el-option
                                            v-for="item in communityList"
                                            :key="item.id"
                                            :label="item.address"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                            <input
                                v-model.trim="formData.address"
                                id="tipinput"
                                class="el-input__inner"
                                :class="
                                    dialogVisibleTitle == '查看' ||
                                    currentStepIndex > 1
                                        ? 'is-disabled'
                                        : ''
                                "
                                disabled
                                @focus="getMap('tipinput')"
                                style="margin-top: 12px"
                                placeholder="请输入关键字"
                                autocomplete="off"
                            />
                            <div class="map_container">
                                <div
                                    class="map_right"
                                    id="container"
                                    style="
                                        width: 100%;
                                        height: 300px;
                                        margin-top: 15px;
                                    "
                                ></div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <!--分配信息表单-->
                <div class="dialog_content_pane" v-show="stepIndex == 2">
                    <el-form
                        label-width="120px"
                        :model="distributionForm"
                        :rules="distributionRules"
                        :disabled="
                            dialogVisibleTitle == '查看' ||
                            currentStepIndex > 2 ||
                            dialogVisibleTitle == '编辑'
                        "
                        ref="distributionForm"
                    >
                        <el-form-item label="分配项目：" prop="projectId">
                            <el-select
                                v-model="distributionForm.projectId"
                                placeholder="请选择分配项目"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="(item, index) in projectManageList"
                                    :key="index"
                                    :label="item.projectName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="分配服务商："
                            prop="serviceProviderId"
                        >
                            <el-select
                                v-model="distributionForm.serviceProviderId"
                                placeholder="请选择分配服务商"
                                style="width: 100%"
                                @change="providerChange"
                            >
                                <el-option
                                    v-for="(item, index) in providerList"
                                    :key="index"
                                    :label="item.constructUnit"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="负责人：">
                            <el-input
                                placeholder="请输入负责人"
                                v-model="distributionForm.leader"
                                :disabled="true"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="服务人员：">
                            <el-checkbox-group
                                v-model="
                                    distributionForm.serviceProviderPersonId
                                "
                                @change="changeId"
                            >
                                <el-checkbox
                                    :label="item.id"
                                    :name="item.id"
                                    v-for="(item, index) in providerPersonList"
                                    :key="index"
                                    >{{ item.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form>
                </div>
                <!--评估信息表单-->
                <div class="dialog_content_pane" v-show="stepIndex == 3">
                    <el-form
                        ref="assessmentForm"
                        :model="assessmentForm"
                        label-width="120px"
                        :disabled="
                            dialogVisibleTitle == '查看' ||
                            currentStepIndex > 3 ||
                            dialogVisibleTitle == '编辑'
                        "
                        class="assessment_Form"
                    >
                        <!-- assessAbandonEnclosure -->
                        <!-- v-if="assessmentForm.currentApprovalStatus == '9'" -->
                        <el-tabs
                            v-model="activeName"
                            type="card"
                            v-if="
                                currentRow.assessAbandonReasons == null &&
                                currentRow.assessAbandonEnclosure == null
                            "
                        >
                            <el-tab-pane label="身体状况" name="first">
                                <el-form-item label="评估项目：">
                                    <div class="inline_wrap inline_wrap_box">
                                        <div class="inline_wrapper">
                                            <span class="inline_label"
                                                >吃饭：</span
                                            >
                                            <el-radio-group
                                                v-model="assessmentForm.eat"
                                                :disabled="true"
                                            >
                                                <el-radio label="0"
                                                    >能</el-radio
                                                >
                                                <el-radio label="1"
                                                    >否</el-radio
                                                >
                                            </el-radio-group>
                                        </div>
                                        <div class="inline_wrapper">
                                            <span class="inline_label"
                                                >穿衣：</span
                                            >
                                            <el-radio-group
                                                v-model="
                                                    assessmentForm.dressing
                                                "
                                                :disabled="true"
                                            >
                                                <el-radio label="0"
                                                    >能</el-radio
                                                >
                                                <el-radio label="1"
                                                    >否</el-radio
                                                >
                                            </el-radio-group>
                                        </div>
                                        <div class="inline_wrapper">
                                            <span class="inline_label"
                                                >上下床：</span
                                            >
                                            <el-radio-group
                                                v-model="assessmentForm.bed"
                                                :disabled="true"
                                            >
                                                <el-radio label="0"
                                                    >能</el-radio
                                                >
                                                <el-radio label="1"
                                                    >否</el-radio
                                                >
                                            </el-radio-group>
                                        </div>
                                        <div class="inline_wrapper">
                                            <span class="inline_label"
                                                >上厕所：</span
                                            >
                                            <el-radio-group
                                                v-model="assessmentForm.toilet"
                                                :disabled="true"
                                            >
                                                <el-radio label="0"
                                                    >能</el-radio
                                                >
                                                <el-radio label="1"
                                                    >否</el-radio
                                                >
                                            </el-radio-group>
                                        </div>
                                        <div class="inline_wrapper">
                                            <span class="inline_label"
                                                >室内走动：</span
                                            >
                                            <el-radio-group
                                                v-model="assessmentForm.walking"
                                                :disabled="true"
                                            >
                                                <el-radio label="0"
                                                    >能</el-radio
                                                >
                                                <el-radio label="1"
                                                    >否</el-radio
                                                >
                                            </el-radio-group>
                                        </div>
                                        <div class="inline_wrapper">
                                            <span class="inline_label"
                                                >洗澡：</span
                                            >
                                            <el-radio-group
                                                v-model="assessmentForm.shower"
                                                :disabled="true"
                                            >
                                                <el-radio label="0"
                                                    >能</el-radio
                                                >
                                                <el-radio label="1"
                                                    >否</el-radio
                                                >
                                            </el-radio-group>
                                        </div>
                                        <div class="inline_wrapper">
                                            <span class="inline_label"
                                                >智力：</span
                                            >
                                            <el-radio-group
                                                v-model="
                                                    assessmentForm.intelligence
                                                "
                                                :disabled="true"
                                            >
                                                <el-radio label="0"
                                                    >能</el-radio
                                                >
                                                <el-radio label="1"
                                                    >否</el-radio
                                                >
                                            </el-radio-group>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="评估结果：">
                                    <el-radio-group
                                        v-model="assessmentForm.assessResult"
                                        :disabled="true"
                                    >
                                        <el-radio label="0">自理</el-radio>
                                        <el-radio label="1">半失能</el-radio>
                                        <el-radio label="2">失能</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="老人自理类别：">
                                    <!-- <el-checkbox-group v-model="assessmentForm.elderlyBelongCategory" :disabled="true">
                    <el-checkbox label="自理" name="0"></el-checkbox>
                    <el-checkbox label="失能" name="1"></el-checkbox>
                    <el-checkbox label="半失能" name="2"></el-checkbox>
                    <el-checkbox label="失智" name="3"></el-checkbox>
                    <el-checkbox label="轻度依赖" name="4"></el-checkbox>
                    <el-checkbox label="重度依赖" name="5"></el-checkbox>
                    <el-checkbox label="不能自理" name="6"></el-checkbox>
                  </el-checkbox-group> -->
                                    <el-radio-group
                                        v-model="
                                            assessmentForm.selfCareCategory
                                        "
                                        :disabled="true"
                                    >
                                        <el-radio label="0">自理</el-radio>
                                        <el-radio label="1">失能</el-radio>
                                        <el-radio label="2">半失能</el-radio>
                                        <el-radio label="3">失智</el-radio>
                                        <el-radio label="4">轻度依赖</el-radio>
                                        <el-radio label="5">重度依赖</el-radio>
                                        <el-radio label="6">不能自理</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="听力状况：">
                                    <el-radio-group
                                        v-model="assessmentForm.hearingStatus"
                                        :disabled="true"
                                    >
                                        <el-radio label="0">良好</el-radio>
                                        <el-radio label="1">一般</el-radio>
                                        <el-radio label="2"
                                            >很大声才能听见</el-radio
                                        >
                                        <el-radio label="3">听不见</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="病史：">
                                    <el-checkbox-group
                                        v-model="assessmentForm.medicalHistory"
                                        :disabled="true"
                                    >
                                        <el-checkbox
                                            label="健康"
                                            name="0"
                                            value="0"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="高血压"
                                            name="1"
                                            value="1"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="糖尿病"
                                            name="2"
                                            value="2"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="冠心病"
                                            name="3"
                                            value="3"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="恶性肿瘤"
                                            name="4"
                                            value="4"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="结核病"
                                            name="5"
                                            value="5"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="肝炎"
                                            name="6"
                                            value="6"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="脑卒中"
                                            name="7"
                                            value="7"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="精神疾病"
                                            name="8"
                                            value="8"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="慢性阻塞性肺疾病"
                                            name="9"
                                            value="9"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="慢性支气管炎"
                                            name="10"
                                            value="10"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="脑血栓"
                                            name="11"
                                            value="11"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="帕金森综合症"
                                            name="12"
                                            value="12"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="腰椎间盘突出"
                                            name="13"
                                            value="13"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="心脏病"
                                            name="14"
                                            value="14"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="肺气肿"
                                            name="15"
                                            value="15"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="风湿病"
                                            name="16"
                                            value="16"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="脑中风"
                                            name="17"
                                            value="17"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="高脂血症"
                                            name="18"
                                            value="18"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="哮喘"
                                            name="19"
                                            value="19"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="意外伤害"
                                            name="20"
                                            value="20"
                                        ></el-checkbox>
                                        <el-checkbox
                                            label="其他"
                                            name="21"
                                            value="12"
                                        ></el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item label="家庭成员评估：">
                                    <el-radio-group
                                        v-model="
                                            assessmentForm.familyMembersAssess
                                        "
                                        :disabled="true"
                                    >
                                        <el-radio label="0">独居</el-radio>
                                        <el-radio label="1"
                                            >与老伴同居</el-radio
                                        >
                                        <el-radio label="2"
                                            >与子女同居</el-radio
                                        >
                                        <el-radio label="3"
                                            >与其他亲属同居</el-radio
                                        >
                                        <el-radio label="4"
                                            >与非亲属同居</el-radio
                                        >
                                    </el-radio-group>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="住宅状况" name="second">
                                <el-form-item label="电梯：">
                                    <el-radio-group
                                        v-model="assessmentForm.elevator"
                                        :disabled="true"
                                    >
                                        <el-radio label="0">有</el-radio>
                                        <el-radio label="1">无</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="室内厕所：">
                                    <el-radio-group
                                        v-model="assessmentForm.indoorToilet"
                                        :disabled="true"
                                    >
                                        <el-radio label="0">有</el-radio>
                                        <el-radio label="1">无</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="室内助浴设备：">
                                    <el-radio-group
                                        v-model="
                                            assessmentForm.indoorBathEquipment
                                        "
                                        :disabled="true"
                                    >
                                        <el-radio label="0">有</el-radio>
                                        <el-radio label="1">无</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="房屋建筑结构：">
                                    <el-radio-group
                                        v-model="
                                            assessmentForm.buildingStructure
                                        "
                                        :disabled="true"
                                    >
                                        <el-radio label="0">框架</el-radio>
                                        <el-radio label="1">砖混</el-radio>
                                        <el-radio label="2">其他</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="居住楼层：">
                                    <el-radio-group
                                        v-model="
                                            assessmentForm.residentialFloor
                                        "
                                        :disabled="true"
                                    >
                                        <el-radio label="0">一层</el-radio>
                                        <el-radio label="1">二层</el-radio>
                                        <el-radio label="2">三层</el-radio>
                                        <el-radio label="3"
                                            >四层及以上</el-radio
                                        >
                                    </el-radio-group>
                                </el-form-item>
                            </el-tab-pane>

                            <el-tab-pane label="居住环境" name="third">
                                <el-form-item
                                    label="评估确认单"
                                    class="check_form_item"
                                >
                                    <div
                                        class="check_upload"
                                        style="margin-left: 40px"
                                    >
                                        <div>
                                            <!-- <div class="avatar">
                        <img
                          :src="checkForm.assessConfirmation"
                          v-if="checkForm.assessConfirmation"
                        />
                        <img src="../assets/img/user.png" v-else />
                      </div> -->
                                            <el-badge
                                                :value="
                                                    imgforms
                                                        .assessConfirmationShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    assessmentForm.assessConfirmation
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .assessConfirmationShows[0]
                                                    "
                                                    v-if="
                                                        assessmentForm.assessConfirmation
                                                    "
                                                    :preview-src-list="
                                                        imgforms.assessConfirmationShows
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-button
                                            size="small"
                                            type="primary"
                                            style="
                                                width: 178px;
                                                margin-top: 20px;
                                            "
                                            >评估单</el-button
                                        >
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="改造前"
                                    class="check_form_item"
                                >
                                    <el-row class="assessment_upload">
                                        <el-col :span="4">
                                            <div>
                                                <el-badge
                                                    :value="
                                                        imgforms
                                                            .balconyPhotoShows
                                                            .length || 0
                                                    "
                                                    type="primary"
                                                    v-if="
                                                        imgforms
                                                            .balconyPhotoShows
                                                            .length > 0
                                                    "
                                                >
                                                    <el-image
                                                        :z-index="3000"
                                                        style="
                                                            width: 100px;
                                                            height: 100px;
                                                        "
                                                        :src="
                                                            imgforms
                                                                .balconyPhotoShows[0]
                                                        "
                                                        :preview-src-list="
                                                            imgforms.balconyPhotoShows
                                                        "
                                                    >
                                                    </el-image>
                                                </el-badge>

                                                <img
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    src="../assets/img/user.png"
                                                    v-else
                                                />
                                            </div>
                                            <el-button
                                                size="small"
                                                type="primary"
                                                style="
                                                    width: 178px;
                                                    margin-top: 20px;
                                                "
                                                >阳台
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4">
                                            <div>
                                                <!-- <div class="avatar">
                        <img
                          :src="assessmentForm.bedroomPhoto"
                          v-if="assessmentForm.bedroomPhoto"
                        />
                        <img src="../assets/img/user.png" v-else />
                      </div> -->
                                                <el-badge
                                                    :value="
                                                        imgforms
                                                            .bedroomPhotoShows
                                                            .length || 0
                                                    "
                                                    type="primary"
                                                    v-if="
                                                        imgforms
                                                            .bedroomPhotoShows
                                                            .length > 0
                                                    "
                                                >
                                                    <el-image
                                                        :z-index="3000"
                                                        style="
                                                            width: 100px;
                                                            height: 100px;
                                                        "
                                                        :src="
                                                            imgforms
                                                                .bedroomPhotoShows[0]
                                                        "
                                                        v-if="
                                                            assessmentForm.bedroomPhoto
                                                        "
                                                        :preview-src-list="
                                                            imgforms.bedroomPhotoShows
                                                        "
                                                    >
                                                    </el-image>
                                                </el-badge>
                                                <img
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    src="../assets/img/user.png"
                                                    v-else
                                                />
                                            </div>
                                            <el-button
                                                size="small"
                                                type="primary"
                                                style="
                                                    width: 178px;
                                                    margin-top: 20px;
                                                "
                                                >卧室
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4">
                                            <div>
                                                <el-badge
                                                    :value="
                                                        imgforms
                                                            .kitchenPhotoShows
                                                            .length || 0
                                                    "
                                                    type="primary"
                                                    v-if="
                                                        imgforms
                                                            .kitchenPhotoShows
                                                            .length > 0
                                                    "
                                                >
                                                    <el-image
                                                        :z-index="3000"
                                                        style="
                                                            width: 100px;
                                                            height: 100px;
                                                        "
                                                        :src="
                                                            imgforms
                                                                .kitchenPhotoShows[0]
                                                        "
                                                        v-if="
                                                            assessmentForm.kitchenPhoto
                                                        "
                                                        :preview-src-list="
                                                            imgforms.kitchenPhotoShows
                                                        "
                                                    >
                                                    </el-image>
                                                </el-badge>
                                                <img
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    src="../assets/img/user.png"
                                                    v-else
                                                />
                                            </div>
                                            <el-button
                                                size="small"
                                                type="primary"
                                                style="
                                                    width: 178px;
                                                    margin-top: 20px;
                                                "
                                                >厨房
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4">
                                            <div>
                                                <el-badge
                                                    :value="
                                                        imgforms
                                                            .livingRoomPhotoShows
                                                            .length || 0
                                                    "
                                                    type="primary"
                                                    v-if="
                                                        imgforms
                                                            .livingRoomPhotoShows
                                                            .length > 0
                                                    "
                                                >
                                                    <el-image
                                                        :z-index="3000"
                                                        style="
                                                            width: 100px;
                                                            height: 100px;
                                                        "
                                                        :src="
                                                            imgforms
                                                                .livingRoomPhotoShows[0]
                                                        "
                                                        v-if="
                                                            assessmentForm.livingRoomPhoto
                                                        "
                                                        :preview-src-list="
                                                            imgforms.livingRoomPhotoShows
                                                        "
                                                    >
                                                    </el-image>
                                                </el-badge>
                                                <img
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    src="../assets/img/user.png"
                                                    v-else
                                                />
                                            </div>
                                            <el-button
                                                size="small"
                                                type="primary"
                                                style="
                                                    width: 178px;
                                                    margin-top: 20px;
                                                "
                                                >客厅
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4">
                                            <div>
                                                <el-badge
                                                    :value="
                                                        imgforms
                                                            .toiletPhotoShows
                                                            .length || 0
                                                    "
                                                    type="primary"
                                                    v-if="
                                                        imgforms
                                                            .toiletPhotoShows
                                                            .length > 0
                                                    "
                                                >
                                                    <el-image
                                                        :z-index="3000"
                                                        style="
                                                            width: 100px;
                                                            height: 100px;
                                                        "
                                                        :src="
                                                            imgforms
                                                                .toiletPhotoShows[0]
                                                        "
                                                        v-if="
                                                            assessmentForm.toiletPhoto
                                                        "
                                                        :preview-src-list="
                                                            imgforms.toiletPhotoShows
                                                        "
                                                    >
                                                    </el-image>
                                                </el-badge>
                                                <img
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    src="../assets/img/user.png"
                                                    v-else
                                                />
                                            </div>
                                            <el-button
                                                size="small"
                                                type="primary"
                                                style="
                                                    width: 178px;
                                                    margin-top: 20px;
                                                "
                                                >卫生间
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                                <div class="table" style="margin-top: 48px">
                                    <el-table
                                        :data="
                                            assessmentForm.elderlySubProManageList
                                        "
                                        tooltip-effect="dark"
                                        style="width: 100%"
                                        :header-cell-style="{
                                            background: '#e6e6e6',
                                            color: '#000',
                                        }"
                                        border
                                    >
                                        <el-table-column
                                            prop="label"
                                            label="产品名称"
                                            align="center"
                                        ></el-table-column>
                                        <el-table-column
                                            prop="number"
                                            label="数量"
                                            align="center"
                                        ></el-table-column>
                                        <el-table-column
                                            prop="openPrice"
                                            label="单价"
                                            align="center"
                                        ></el-table-column>
                                        <el-table-column
                                            prop="price"
                                            label="费用(元)"
                                            align="center"
                                        ></el-table-column>
                                    </el-table>
                                    <div
                                        class="total_wrapper"
                                        v-if="
                                            assessmentForm
                                                .elderlySubProManageList
                                                .length != 0
                                        "
                                    >
                                        <span class="total_title"
                                            >费用（合计）</span
                                        >
                                        <span class="total_count">{{
                                            detailTatol
                                        }}</span>
                                    </div>
                                    <!--<div class="pagination_container">
                    <el-pagination
                      :page-sizes="[10, 20, 50, 100]"
                      :page-size="10"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="6"
                    ></el-pagination>
                  </div>-->
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <!-- v-if="assessmentForm.currentApprovalStatus == '10'" -->
                        <template v-else>
                            <el-form-item label="放弃原因：">
                                <el-input
                                    type="textarea"
                                    :rows="5"
                                    v-model="
                                        assessmentForm.assessAbandonReasons
                                    "
                                    :disabled="true"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="放弃证明：">
                                <div>
                                    <div class="avatar">
                                        <img
                                            :src="
                                                assessmentForm.assessAbandonEnclosure
                                            "
                                            v-if="
                                                assessmentForm.assessAbandonEnclosure
                                            "
                                        />
                                        <img
                                            src="../assets/img/user.png"
                                            v-else
                                        />
                                    </div>
                                </div>
                            </el-form-item>
                        </template>
                        <el-form-item label="审核状态：">
                            <el-radio-group
                                v-model="assessmentForm.assessApprovalStatus"
                            >
                                <el-radio :label="0">审核不通过</el-radio>
                                <el-radio :label="1">审核通过</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="原因：">
                            <el-input
                                type="textarea"
                                :rows="5"
                                v-model="assessmentForm.assessApprovalReasons"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <!--施工督查表单-->
                <div class="dialog_content_pane" v-show="stepIndex == 4">
                    <el-form
                        ref="checkForm"
                        :model="checkForm"
                        label-width="120px"
                        :disabled="
                            dialogVisibleTitle == '查看' || currentStepIndex > 4
                        "
                    >
                        <!-- label-position="top" -->
                        <!-- approvalStatus -->
                        <!-- v-if="checkForm.currentApprovalStatus == 11" -->
                        <div
                            v-if="
                                currentRow.constructionAbandonReasons == null &&
                                currentRow.constructionAbandonEnclosure == null
                            "
                        >
                            <el-form-item
                                label="改造项目："
                                class="check_form_item"
                            >
                                <el-row class="assessment_upload">
                                    <el-col :span="4">
                                        <div @click="showImg('阳台前')">
                                            <el-badge
                                                :value="
                                                    imgforms.balconyPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms.balconyPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .balconyPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >阳台改造前</el-button
                                            >
                                        </el-upload>
                                        <div
                                            style="margin-top: 12px"
                                            @click="showImg('阳台后')"
                                        >
                                            <el-badge
                                                :value="
                                                    imgforms
                                                        .balconyAfterPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms
                                                        .balconyAfterPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .balconyAfterPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess1"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >阳台改造后</el-button
                                            >
                                        </el-upload>
                                    </el-col>
                                    <el-col :span="4">
                                        <div @click="showImg('卧室前')">
                                            <el-badge
                                                :value="
                                                    imgforms.bedroomPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms.bedroomPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .bedroomPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess2"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >卧室改造前</el-button
                                            >
                                        </el-upload>
                                        <div
                                            style="margin-top: 12px"
                                            @click="showImg('卧室后')"
                                        >
                                            <el-badge
                                                :value="
                                                    imgforms
                                                        .bedroomAfterPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms
                                                        .bedroomAfterPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .bedroomAfterPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess3"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >卧室改造后</el-button
                                            >
                                        </el-upload>
                                    </el-col>
                                    <el-col :span="4">
                                        <div @click="showImg('厨房前')">
                                            <el-badge
                                                :value="
                                                    imgforms.kitchenPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms.kitchenPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .kitchenPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess4"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >厨房改造前</el-button
                                            >
                                        </el-upload>
                                        <div
                                            style="margin-top: 12px"
                                            @click="showImg('厨房后')"
                                        >
                                            <el-badge
                                                :value="
                                                    imgforms
                                                        .kitchenAfterPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms
                                                        .kitchenAfterPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .kitchenAfterPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess5"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >厨房改造后</el-button
                                            >
                                        </el-upload>
                                    </el-col>
                                    <el-col :span="4">
                                        <div @click="showImg('客厅前')">
                                            <el-badge
                                                :value="
                                                    imgforms
                                                        .livingRoomPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms
                                                        .livingRoomPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .livingRoomPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess6"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >客厅改造前</el-button
                                            >
                                        </el-upload>
                                        <div
                                            style="margin-top: 12px"
                                            @click="showImg('客厅后')"
                                        >
                                            <el-badge
                                                :value="
                                                    imgforms
                                                        .livingRoomAfterPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms
                                                        .livingRoomAfterPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .livingRoomAfterPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess7"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >客厅改造后</el-button
                                            >
                                        </el-upload>
                                    </el-col>
                                    <el-col :span="4">
                                        <div @click="showImg('卫生间前')">
                                            <el-badge
                                                :value="
                                                    imgforms.toiletPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms.toiletPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .toiletPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess8"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >卫生间改造前</el-button
                                            >
                                        </el-upload>
                                        <div
                                            style="margin-top: 12px"
                                            @click="showImg('卫生间后')"
                                        >
                                            <el-badge
                                                :value="
                                                    imgforms
                                                        .toiletAfterPhotoShows
                                                        .length || 0
                                                "
                                                type="primary"
                                                v-if="
                                                    imgforms
                                                        .toiletAfterPhotoShows
                                                        .length > 0
                                                "
                                            >
                                                <el-image
                                                    :z-index="3000"
                                                    style="
                                                        width: 100px;
                                                        height: 100px;
                                                    "
                                                    :src="
                                                        imgforms
                                                            .toiletAfterPhotoShows[0]
                                                    "
                                                >
                                                </el-image>
                                            </el-badge>
                                            <img
                                                style="
                                                    width: 100px;
                                                    height: 100px;
                                                "
                                                src="../assets/img/user.png"
                                                v-else
                                            />
                                        </div>
                                        <el-upload
                                            :show-file-list="false"
                                            :action="baseUrl"
                                            accept=".png,.jpg,.jpeg"
                                            multiple
                                            class="pictreus"
                                            :disabled="
                                                dialogVisibleTitle !==
                                                    '施工督查' && changeImg
                                            "
                                            :on-success="houseSuccess9"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                        >
                                            <el-button
                                                size="small"
                                                type="primary"
                                                >卫生间改造后</el-button
                                            >
                                        </el-upload>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </div>

                        <!-- v-if="checkForm.currentApprovalStatus == 12" -->
                        <template v-else>
                            <el-form-item label="放弃原因：">
                                <el-input
                                    type="textarea"
                                    :rows="5"
                                    v-model="
                                        checkForm.constructionAbandonReasons
                                    "
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="放弃证明：">
                                <div class="avatar">
                                    <img
                                        :src="
                                            checkForm.constructionAbandonEnclosure
                                        "
                                        v-if="
                                            checkForm.constructionAbandonEnclosure
                                        "
                                    />
                                    <img src="../assets/img/user.png" v-else />
                                </div>
                            </el-form-item>
                        </template>
                        <div class="showImg" v-if="showImgList">
                            <div
                                class="pre el-icon-arrow-left"
                                @click="jian(imgIndex)"
                            ></div>
                            <div class="close" @click="closeImgList">×</div>
                            <div class="tebIndex">
                                <span v-if="imgList.length == 0">0</span>
                                <span v-else>{{ imgIndex + 1 }}</span> /
                                {{ imgList.length }}
                            </div>
                            <div
                                class="img"
                                v-for="(item, index) in imgList"
                                :key="index"
                                v-if="index == imgIndex"
                            >
                                <div class="delImg" @click="delImg(index)">
                                    ×
                                </div>
                                <img :src="item" />
                            </div>
                            <div
                                class="next el-icon-arrow-right"
                                @click="jia(imgIndex)"
                            ></div>
                        </div>
                        <el-form-item label="审核状态：">
                            <el-radio-group
                                v-model="checkForm.constructionApprovalStatus"
                                :disabled="
                                    dialogVisibleTitle == '查看' ||
                                    dialogVisibleTitle == '编辑'
                                "
                            >
                                <el-radio :label="0">审核不通过</el-radio>
                                <el-radio :label="1">审核通过</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="原因：">
                            <el-input
                                type="textarea"
                                :rows="5"
                                v-model="checkForm.constructionApprovalReasons"
                                :disabled="
                                    dialogVisibleTitle == '查看' ||
                                    dialogVisibleTitle == '编辑'
                                "
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <!--评价表单-->
                <div class="dialog_content_pane" v-show="stepIndex == 5">
                    <el-form
                        ref="evaluateForm"
                        :model="evaluateForm"
                        :rules="evaluateFormRules"
                        label-width="120px"
                        label-position="left"
                        :disabled="
                            dialogVisibleTitle == '查看' ||
                            currentStepIndex > 5 ||
                            dialogVisibleTitle == '编辑'
                        "
                    >
                        <el-form-item label="评价类型：" prop="assessType">
                            <el-radio-group
                                v-model="evaluateForm.assessType"
                                @change="evaluateTypeChange"
                            >
                                <el-radio
                                    :label="item.id"
                                    v-for="(item, index) in evaluateTypetList"
                                    :key="index"
                                    >{{ item.typeName }}
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="发布方式：" prop="assessType">
                            <el-radio-group
                                disabled
                                v-model="evaluateForm.publishPlatform"
                            >
                                <el-radio label="0">APP</el-radio>
                                <el-radio label="1">web</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="选择部门：" prop="selectDeptId">
                            <el-select
                                v-model="evaluateForm.selectDeptId"
                                @change="chooseDepartmentChange"
                                placeholder="请选择部门"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="(
                                        item, index
                                    ) in chooseDepartmentList"
                                    :key="index"
                                    :label="item.deptName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="选择人员：" prop="selectPersonId">
                            <el-select
                                v-model="evaluateForm.selectPersonId"
                                placeholder="请选择人员"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="(item, index) in choosePersonnelList"
                                    :key="index"
                                    :label="item.personName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <template v-if="evaluateTypeList.length > 0">
                            <template v-for="(item, index) in evaluateTypeList">
                                <div :key="index">
                                    <el-form-item label="问题：">
                                        <el-input
                                            v-model="item.questionName"
                                            placeholder="请输入问题"
                                            :disabled="true"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="回复选择：">
                                        <el-radio-group
                                            v-model="item.replySelection"
                                            :disabled="true"
                                        >
                                            <el-radio label="0">是</el-radio>
                                            <el-radio label="1">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item
                                        label="原因："
                                        placeholder="请输入内容"
                                    >
                                        <el-input
                                            type="textarea"
                                            :rows="3"
                                            v-model="item.reason"
                                            :disabled="true"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </template>
                        </template>
                        <!-- evaluateTypeList -->
                    </el-form>
                </div>
                <!--回访工单表单-->
                <div class="dialog_content_pane" v-show="stepIndex == 6">
                    <el-form
                        ref="returnVisitForm"
                        class="return_visit_form"
                        :model="returnVisitForm"
                        label-width="120px"
                        label-position="left"
                        :disabled="
                            dialogVisibleTitle == '查看' ||
                            dialogVisibleTitle == '编辑'
                        "
                    >
                        <div class="header">
                            <span
                                >老人姓名：
                                {{
                                    this.currentRow &&
                                    this.currentRow.customerName
                                }}</span
                            ><span
                                >电话：{{
                                    this.currentRow && this.currentRow.phone
                                }}</span
                            >
                        </div>
                        <template v-if="returnVisitList.length > 0">
                            <template v-for="(item, index) in returnVisitList">
                                <div :key="index">
                                    <el-form-item label="问题：">
                                        <el-input
                                            v-model="item.questionName"
                                            placeholder="请输入问题"
                                            :disabled="true"
                                        ></el-input>
                                        <!-- :disabled="true" -->
                                    </el-form-item>
                                    <!-- :disabled="dialogVisibleTitle == '查看' || currentStepIndex > 6" -->
                                    <el-form-item label="回复选择：">
                                        <el-radio-group
                                            v-model="item.replySelection"
                                        >
                                            <el-radio label="0">是</el-radio>
                                            <el-radio label="1">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item
                                        label="原因："
                                        placeholder="请输入内容"
                                    >
                                        <el-input
                                            type="textarea"
                                            :rows="3"
                                            v-model="item.reason"
                                            :disabled="
                                                dialogVisibleTitle == '查看' ||
                                                currentStepIndex > 6
                                            "
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </template>
                        </template>
                    </el-form>
                </div>
                <!--完成-->
                <div class="dialog_content_pane" v-show="stepIndex == 7">
                    <el-form
                        ref="endForm"
                        class="return_visit_form"
                        :model="endForm"
                        label-width="150px"
                        label-position="left"
                        :disabled="
                            dialogVisibleTitle == '查看' ||
                            currentStepIndex > 7 ||
                            dialogVisibleTitle == '编辑'
                        "
                    >
                        <el-form-item label="是否是推荐案例：">
                            <el-radio-group v-model="endForm.cases">
                                <el-radio label="0">是</el-radio>
                                <el-radio label="1">否</el-radio>
                            </el-radio-group>
                        </el-form-item>

                        <template
                            v-if="
                                elderlyInformationList &&
                                elderlyInformationList.length > 0
                            "
                        >
                            <template
                                v-for="(item, index) in elderlyInformationList"
                            >
                                <div :key="index">
                                    <el-form-item label="问题：">
                                        <el-input
                                            v-model="item.questionName"
                                            placeholder="请输入问题"
                                            :disabled="true"
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item label="回复选择：">
                                        <el-radio-group
                                            v-model="item.replySelection"
                                            :disabled="true"
                                        >
                                            <el-radio label="0">是</el-radio>
                                            <el-radio label="1">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                    <el-form-item
                                        label="原因："
                                        placeholder="请输入内容"
                                    >
                                        <el-input
                                            type="textarea"
                                            :rows="3"
                                            v-model="item.reason"
                                            :disabled="true"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </template>
                        </template>
                        <!-- <el-form-item label="附件：">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="(file, fileList) => { handleAvatarSuccess(file, fileList, 'endFormImages') }">
                <img v-if="endFormImages" :src="endFormImages" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item> -->
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    :disabled="isdisabled"
                    @click="submitForm"
                    v-show="
                        stepIndex == 0 ||
                        stepIndex == stepIndexStatus ||
                        !changeImg
                    "
                    >确 定</el-button
                >
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 打印弹窗 -->
        <el-dialog
            title="打印"
            :visible.sync="printDialogVisiblebefore"
            class="dialog_container"
            @close="printDialogVisibleClose"
            width="60%"
        >
            <div ref="print" class="print_container dialog_content">
                <h3 class="print_title">适老化改造需求评估表</h3>
                <div class="address_wrap">
                    <div class="item">
                        <span>{{ printForm.shiName }}</span
                        >市
                    </div>
                    <div class="item">
                        <span>{{ printForm.jiedaoName }}</span
                        >街道
                    </div>
                    <div class="item">
                        <span>{{ printForm.shequName }}</span
                        >社区
                    </div>
                </div>
                <table class="table_container">
                    <tr class="user_info">
                        <td class="label">老人姓名</td>
                        <td class="content" style="width: 160px">
                            {{ printForm.name }}
                        </td>
                        <td class="label">身份证号</td>
                        <td class="content">{{ printForm.idCard }}</td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">联系方式</td>
                        <td class="content">{{ printForm.phone }}</td>
                        <td class="label">改造地址</td>
                        <td class="content">{{ printForm.address }}</td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">身体状况评估</td>
                        <td class="content_full" colspan="3">
                            <p class="inline_title">评估项目：</p>
                            <div class="inline_wrap inline_wrap_box">
                                <div class="inline_wrapper">
                                    <span class="inline_label">吃饭：</span>
                                    <el-checkbox-group
                                        v-model="printForm.eat"
                                        @change="changeProject"
                                        class="change_project"
                                    >
                                        <el-checkbox label="0">能</el-checkbox>
                                        <el-checkbox label="1">否</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="inline_wrapper">
                                    <span class="inline_label">穿衣：</span>
                                    <el-checkbox-group
                                        v-model="printForm.dressing"
                                        @change="changeProject"
                                        class="change_project"
                                    >
                                        <el-checkbox label="0">能</el-checkbox>
                                        <el-checkbox label="1">否</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="inline_wrapper">
                                    <span class="inline_label">上下床：</span>
                                    <el-checkbox-group
                                        v-model="printForm.bed"
                                        @change="changeProject"
                                        class="change_project"
                                    >
                                        <el-checkbox label="0">能</el-checkbox>
                                        <el-checkbox label="1">否</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="inline_wrapper">
                                    <span class="inline_label">上厕所：</span>
                                    <el-checkbox-group
                                        v-model="printForm.toilet"
                                        @change="changeProject"
                                        class="change_project"
                                    >
                                        <el-checkbox label="0">能</el-checkbox>
                                        <el-checkbox label="1">否</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="inline_wrapper">
                                    <span class="inline_label">室内走动：</span>
                                    <el-checkbox-group
                                        v-model="printForm.walking"
                                        @change="changeProject"
                                        class="change_project"
                                    >
                                        <el-checkbox label="0">能</el-checkbox>
                                        <el-checkbox label="1">否</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="inline_wrapper">
                                    <span class="inline_label">洗澡：</span>
                                    <el-checkbox-group
                                        v-model="printForm.shower"
                                        @change="changeProject"
                                        class="change_project"
                                    >
                                        <el-checkbox label="0">能</el-checkbox>
                                        <el-checkbox label="1">否</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="inline_wrapper">
                                    <span class="inline_label">智力：</span>
                                    <el-checkbox-group
                                        v-model="printForm.intelligence"
                                        @change="changeProject"
                                        class="change_project"
                                    >
                                        <el-checkbox label="0">能</el-checkbox>
                                        <el-checkbox label="1">否</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                            <p class="inline_title">评估结果：</p>
                            <div class="inline_wrap">
                                <el-checkbox-group
                                    v-model="printForm.assessResult"
                                    @change="changeProject"
                                    class="change_project"
                                >
                                    <el-checkbox label="0">自理</el-checkbox>
                                    <el-checkbox label="1">半失能</el-checkbox>
                                    <el-checkbox label="2">失能</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <p class="inline_tips">
                                备注：评估项中，一项二项"做不了"的定义为"轻度失能"；三到四项"做不了"的定义为"中度失能"；五到六项"做不了的定义为"重度失能"
                            </p>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">住宅状况及居家环境评估</td>
                        <td class="content" colspan="3">
                            <div class="inline_wrap">
                                <span class="inline_label">电梯：</span>
                                <el-checkbox-group
                                    v-model="printForm.elevator"
                                    @change="changeProject"
                                    class="change_project"
                                >
                                    <el-checkbox label="0">有</el-checkbox>
                                    <el-checkbox label="1">无</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="inline_wrap">
                                <span class="inline_label">室内厕所：</span>
                                <el-checkbox-group
                                    v-model="printForm.indoorToilet"
                                    @change="changeProject"
                                    class="change_project"
                                >
                                    <el-checkbox label="0">有</el-checkbox>
                                    <el-checkbox label="1">无</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="inline_wrap">
                                <span class="inline_label">室内助浴设备：</span>
                                <el-checkbox-group
                                    v-model="printForm.indoorBathEquipment"
                                    @change="changeProject"
                                    class="change_project"
                                >
                                    <el-checkbox label="0">有</el-checkbox>
                                    <el-checkbox label="1">无</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="inline_wrap">
                                <span class="inline_label">房屋建筑结构：</span>
                                <el-checkbox-group
                                    v-model="printForm.buildingStructure"
                                    @change="changeProject"
                                    class="change_project"
                                >
                                    <el-checkbox label="0">框架</el-checkbox>
                                    <el-checkbox label="1">砖混</el-checkbox>
                                    <el-checkbox label="2">其他</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="inline_wrap">
                                <span class="inline_label">居住楼层：</span>
                                <el-checkbox-group
                                    v-model="printForm.residentialFloor"
                                    @change="changeProject"
                                    class="change_project"
                                >
                                    <el-checkbox label="0">一层</el-checkbox>
                                    <el-checkbox label="1">二层</el-checkbox>
                                    <el-checkbox label="2">三层</el-checkbox>
                                    <el-checkbox label="3"
                                        >四层及以上</el-checkbox
                                    >
                                </el-checkbox-group>
                            </div>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">家庭成员评估</td>
                        <td class="content" colspan="3">
                            <div class="inline_wrap">
                                <el-checkbox-group
                                    v-model="printForm.familyMembersAssess"
                                    @change="changeProject"
                                    class="change_project"
                                >
                                    <el-checkbox label="0">独居</el-checkbox>
                                    <el-checkbox label="1"
                                        >与老伴同居</el-checkbox
                                    >
                                    <el-checkbox label="2"
                                        >与子女同居</el-checkbox
                                    >
                                    <el-checkbox label="3"
                                        >与其他亲属同居</el-checkbox
                                    >
                                    <el-checkbox label="4"
                                        >与非亲属同居</el-checkbox
                                    >
                                </el-checkbox-group>
                            </div>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">改造方案设计</td>
                        <td class="content" colspan="3">
                            <table class="inline_table">
                                <tr>
                                    <td style="width: 180px">改造项目</td>
                                    <td class="reform_wrap">
                                        <p>改造内容</p>
                                        <p class="reform_content">
                                            <span>产品名称</span
                                            ><span>数量</span><span>单价</span>
                                        </p>
                                    </td>
                                    <td style="width: 180px">预估费用（元）</td>
                                </tr>
                                <template
                                    v-if="
                                        printForm.elderlySubProManageList &&
                                        printForm.elderlySubProManageList
                                            .length > 0
                                    "
                                >
                                    <tr
                                        v-for="(
                                            item, index
                                        ) in printForm.elderlySubProManageList"
                                        :key="index"
                                    >
                                        <td>{{ item.projectName }}</td>
                                        <td class="reform_wrap">
                                            <p class="reform_content_c">
                                                <span>{{
                                                    item.productName
                                                }}</span>
                                                <span>{{ item.number }}</span>
                                                <span>{{
                                                    item.openPrice
                                                }}</span>
                                            </p>
                                        </td>
                                        <td>{{ item.price }}</td>
                                    </tr>
                                </template>
                                <tr
                                    v-if="
                                        printForm.elderlySubProManageList &&
                                        printForm.elderlySubProManageList
                                            .length > 0
                                    "
                                >
                                    <td>预估费用合计</td>
                                    <td colspan="2">
                                        <p class="price_wrap">
                                            <span clsas="">{{
                                                printForm.totalPrice
                                            }}</span
                                            >元
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">备注</td>
                        <td class="content" colspan="3"></td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">评估确认</td>
                        <td class="content" colspan="3">
                            <p class="inline_title">
                                本人(
                                <span
                                    ><el-checkbox label="是"></el-checkbox
                                    ><el-checkbox
                                        label="否"
                                    ></el-checkbox></span
                                >)认同上述评估结果，同意按设计方案进行施工改造，愿意承担因施工改造产品的一切后果。
                            </p>
                            <div class="sign">老年人（亲属）签字：</div>
                            <div class="date">
                                <span>年</span><span>月</span><span>日</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">结果确认</td>
                        <td class="content" colspan="3">
                            <p class="inline_title">
                                本人及本组织（企业）承诺对以上评估结果负责，愿意承担因评估不当产生的一切不良后果。
                            </p>
                            <div class="sign">评估人签字：</div>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">村（社区）意见</td>
                        <td class="content" colspan="3">
                            <div class="sign_ont">签字（章）：</div>
                            <div class="date">
                                <span>年</span><span>月</span><span>日</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">镇（街道）意见</td>
                        <td class="content" colspan="3">
                            <div class="sign_ont">签字（章）：</div>
                            <div class="date">
                                <span>年</span><span>月</span><span>日</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">县民政局意见</td>
                        <td class="content" colspan="3">
                            <div class="sign_ont">签字（章）：</div>
                            <div class="date">
                                <span>年</span><span>月</span><span>日</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="printDialogVisiblebefore = false"
                    >关闭</el-button
                >
                <el-button type="primary" @click="handlePrint">打印</el-button>
            </span>
        </el-dialog>

        <!-- 打印弹窗2 -->
        <el-dialog
            title="打印"
            :visible.sync="printDialogVisible"
            class="dialog_container"
            @close="printDialogVisibleClose"
            width="60%"
        >
            <div ref="print" class="print_container dialog_content">
                <h3 class="print_title">
                    {{ printForm.shiName }}特殊困难老年人家庭适老化改造验收表
                </h3>

                <table class="table_container">
                    <tr class="user_info">
                        <td class="label">老人姓名</td>
                        <td class="content" style="width: 270px">
                            {{ printForm.customerName }}
                        </td>
                        <td class="label">联系方式</td>
                        <td class="content" style="width: 270px">
                            {{ printForm.phone }}
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">身份证号</td>
                        <td class="content" colspan="3">
                            {{ printForm.idCard }}
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">改造地址</td>
                        <td class="content" colspan="3">
                            {{ printForm.address }}
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">改造情况</td>
                        <td class="content" colspan="3" style="padding: 0">
                            <tr class="inner-tr">
                                <td style="width: 204px">改造内容</td>
                                <td style="width: 204px">改造数量</td>
                                <td style="width: 204px">改造时间</td>
                                <td style="width: 320px">施工人员(签字)</td>
                            </tr>

                            <template
                                v-if="
                                    printForm.elderlySubProManageList &&
                                    printForm.elderlySubProManageList.length > 0
                                "
                            >
                                <tr
                                    class="inner-tr"
                                    v-for="(
                                        item, index
                                    ) in printForm.elderlySubProManageList"
                                    :key="index"
                                >
                                    <td>{{ item.productName }}</td>
                                    <td>{{ item.number }}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </template>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">验收结果</td>
                        <td class="content_full" colspan="3">
                            <div class="inline_wrap">
                                <el-checkbox-group
                                    v-model="printForm.assessResult"
                                    @change="changeProject"
                                    class="change_project"
                                >
                                    <el-checkbox label="0">合格</el-checkbox>
                                    <el-checkbox label="1">不合格</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <p class="inline_tips">验收人（签字）：</p>
                            <div class="date">
                                <span>年</span><span>月</span><span>日</span>
                            </div>
                        </td>
                    </tr>

                    <tr class="user_info">
                        <td class="label">结果确认</td>
                        <td class="content" colspan="3">
                            <p class="inline_title">
                                本人(
                                <span
                                    ><el-checkbox label="是"></el-checkbox
                                    ><el-checkbox
                                        label="否"
                                    ></el-checkbox></span
                                >)认同上述施工改造结果，确认按评估结果完成施工改造，签订相关服务协议。
                            </p>
                            <div class="sign">老年人（亲属）签字：</div>
                            <div class="date">
                                <span>年</span><span>月</span><span>日</span>
                            </div>
                        </td>
                    </tr>
                    <tr class="user_info">
                        <td class="label">县级民政部门意见</td>
                        <td class="content" colspan="3">
                            <div class="sign_ont">签字（章）：</div>
                            <div class="date">
                                <span>年</span><span>月</span><span>日</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="printDialogVisible = false">关闭</el-button>
                <el-button type="primary" @click="handlePrint">打印</el-button>
            </span>
        </el-dialog>
        <!-- 清除手机号座机号 -->
        <el-dialog
            title="是否清除"
            width="300px"
            :visible.sync="dialogVisible6"
        >
            <el-checkbox-group v-model="isphone">
                <el-checkbox label="清除手机号"></el-checkbox>
                <el-checkbox label="清除座机号"></el-checkbox>
            </el-checkbox-group>
            <div slot="footer">
                <el-button type="primary" @click="saveClear">确定</el-button>
                <el-button @click="Clears">取消</el-button>
            </div>
        </el-dialog>
        <!-- 删除施工督查图片 -->
        <el-dialog
            :title="vehicleTitle"
            :visible.sync="vehicleVisible"
            width="700px"
        >
            <div style="display: flex; margin: 20px 0">
                <div
                    class="vehiclecal"
                    v-for="(item, index) in this.vehicleList"
                    :key="index"
                >
                    <img
                        :src="item"
                        style="width: 100px; heigth: 100px; margin: 10px"
                    />
                    <span class="maskIcons">
                        <span
                            class="imgdel"
                            @click="vehicledelete(item, index)"
                        >
                            <i class="el-icon-delete"></i>
                        </span>
                    </span>
                </div>
            </div>
            <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="vehicleVisible = false">取 消</el-button>
            <el-button type="primary" @click="vehicleVisible = false">确 定</el-button>
        </span> -->
        </el-dialog>
    </div>
</template>

<script>
import globalTag from "../components/globalTag"
import common from "../../../utils/common.js"
import baseURL from "@/api/baseURL"
import "@/utils/addToolbar"
import AMap from "AMap" // 引入高德地图
import { discriCard, chekCode, chekPhone } from "../util"
import { getLetterWidth } from "@antv/g6/lib/util/graphic"
import Vue from "vue"
import vueQr from "vue-qr"
import { findActivityName } from "../../../api/http"
import request from "@/utils/request.js"
export default {
    name: "elderInfo",
    data() {
        var checkIdCode = (rule, value, callback) => {
            if (!chekCode(value)) {
                return callback(new Error("身份证号格式错误"))
            }
            const info = discriCard(value)
            this.formData.age = info.age
            this.formData.gender = info.gender
            callback()
        }
        // var chekPhone = (rule, value, callback) => {
        //   // let validatePhone = /^1[3|4|5|7|8][0-9]{9}$/;
        //   let validatePhone = /^1[0-9]{10}$/
        //   if (!validatePhone.test(value)) {
        //     return callback(new Error('手机号格式错误'))
        //   }
        //   callback()
        // }
        return {
            vehicleTitle: "",
            vehicleVisible: false,
            vehicleList: [],
            defaultProps: {
                children: "children",
                label: "label",
            },
            formDataEdit: [
                {
                    name: "",
                    idCard: "",
                    gender: "",
                    phone: "",
                    age: "",
                    address: "",
                    elderlyBelongCategory: "",
                    familyCall: "",
                },
            ],
            datasid: "",
            dialogVisible6: false,
            isphone: [],
            oldtypeLits: [],
            //新增/查看表单
            //编辑表单数据
            isdisabled: false,
            orgList: [],
            arrOrgList: [],
            ssorgList: [],
            printDialogVisible: false, //打印弹窗2
            printDialogVisiblebefore: false, //打印弹窗
            selectedData: [],
            form: {
                provinceId: "", //居住地址
                cityid: "", //居住地址
                zoneid: "", //居住地址
                streetid: "", //居住地址
                shequid: "", //居住地址
            },
            customerName: "",
            printForm: {
                //打印form表单
                name: "", //姓名
                idCard: "", //身份证号
                phone: "", //联系方式
                modificationAddress: "", //改造地址
                assessmentProject: [], //
                assessmentProjectResult: [],
                familyMembersAssess: [], //家庭成员评估
                elevator: [], //电梯
                indoorToilet: [], //室内厕所
                indoorBathEquipment: [], //室内助浴设备
                buildingStructure: [], //房屋建筑结构
                residentialFloor: [], //居住楼层
                elderlySubProManageList: [],
                address: "",
                shengName: "",
                shiName: "",
                quName: "",
                jiedaoName: "",
                shequName: "",
                assessResult: [],
                intelligence: [],
                shower: [],
                walking: [],
                toilet: [],
                dressing: [],
                eat: [],
                bed: [],
            },
            projectId: "",
            name: "",
            serviceProviderId: "",
            serviceProviderPersonId: "",
            addProblemList: [],
            setUpDialog: false,
            addDialogData: [],
            addDialog: false, //评价内容弹窗
            activeName: "first", //tabs下标
            stepIndex: 0, //当前步骤下标
            stepIndexStatus: 0,
            imageUrl: "", //图片地址
            imageUrlSix: "", //评估放弃证明图片地址
            proveImageUrl: "", //施工督查放弃证明图片地址
            setUpDialogDeit: false, //编辑弹框
            returnVisitImages: "", //回访工单附件图片地址
            setUpDialogFormImg: "", //评价内容
            username: "", //姓名
            gender: "", // 性别
            options: [],
            loading: false,
            tempTableChekbox: [
                "序号",
                "姓名",
                "性别",
                "联系方式",
                "身份证号",
                "年龄",
                "老人类型",
                "居住地址",
                "创建人",
                "审核状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "姓名",
                "性别",
                "联系方式",
                "身份证号",
                "年龄",
                "老人类型",
                "居住地址",
                "创建人",
                "审核状态",
                "操作",
            ],
            idCard: "", //身份证号
            tableData: [], // tabble数据
            // tableDataPageNo: 1,
            // tableDataPageSize: 10,
            // tableDataCount: 0,
            tatol: 0,
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            publishPlatform: "",
            restaurants: [],
            formData: {
                //新增/查看表单
                name: "", //姓名
                gender: "0", //性别
                phone: "", //联系方式
                idCard: "", //身份证号
                age: "", //年龄
                elderlyBelongCategory: "", //老人类型
                provinceId: "", //省
                cityId: "", //市
                areaId: "", //区
                street: "", //街道
                streetId: "",
                communityId: Number,
                community: "", //社区
                address: "", //居住地址
                photo: "", //图片
                longitude: "", //经度
                latitude: "", //纬度
                orgId: "",
                orgName: "",
                familyCall: "",
            },
            elderlyBelongCategoryList: [
                "特困老人",
                "低保老人",
                "建档立卡贫困老人",
                "优抚对象",
                "失独老人",
                "残疾老人",
                "计划生育特殊家庭成员",
                "空巢老人",
                "农村留守老人",
                "80岁以上老人",
                "其他",
            ],
            formDataRules: {
                oldId: [
                    { required: true, message: "请输入姓名", trigger: "blur" },
                ],
                // orgName: [{ required: true, message: "请选择组织机构", trigger: "change" }],
                // phone: [
                //   {
                //     required: true,
                //     message: '请输入联系方式',
                //     trigger: 'blur'
                //   },
                //   { validator: chekPhone, trigger: 'blur' }
                // ],
                idCard: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur",
                    },
                    { validator: checkIdCode, trigger: "blur" },
                ],
                provinceId: [
                    { required: true, message: "请选择省", trigger: "blur" },
                ],
                cityId: [
                    { required: true, message: "请选择市", trigger: "blur" },
                ],
                areaId: [
                    { required: true, message: "请选择区", trigger: "blur" },
                ],
                streetId: [
                    { required: true, message: "请选择街道", trigger: "blur" },
                ],
                communityId: [
                    { required: true, message: "请选择社区", trigger: "blur" },
                ],
                address: [
                    { required: true, message: "请输入地址", trigger: "blur" },
                ],
            },
            distributionForm: {
                //分配表单
                projectId: "", //分配项目
                serviceProviderId: "", //分配服务商
                leader: "", //负责人
                serviceProviderPersonId: [], //施工员
            },
            distributionRules: {
                //分配表单验证规则
                projectId: [
                    { required: true, message: "请选择项目", trigger: "blur" },
                ],
                serviceProviderId: [
                    {
                        required: true,
                        message: "请选择服务商",
                        trigger: "blur",
                    },
                ],
            },

            projectManageList: [], //项目列表
            providerList: [], //服务商列表
            providerPersonList: [], //施工员列表
            providerPersonList1: [], //施工员列表

            imgforms: {
                balconyPhotoShows: [], //阳台改造前
                bedroomPhotoShows: [], //卧室改造前
                kitchenPhotoShows: [], //厨房改造前
                livingRoomPhotoShows: [], //客厅改造前
                toiletPhotoShows: [], //卫生间改造前
                balconyAfterPhotoShows: [], //阳台改造后
                bedroomAfterPhotoShows: [], //卧室改造后
                kitchenAfterPhotoShows: [], //厨房改造后
                livingRoomAfterPhotoShows: [], //客厅改造后
                toiletAfterPhotoShows: [], //卫生间改造后
                assessConfirmationShows: [], //评估单
                elderlyPhotoList: {
                    names: [],
                    photos: [],
                    afterphotos: [],
                }, //新增项目列表
            },
            assessmentForm: {
                assessConfirmation: "",
                //评估审核表单
                selfCareCategory: "", //老人类别
                hearingStatus: "", //听力状况
                medicalHistory: [], //病史
                familyMembersAssess: "", //家庭成员评估
                elevator: "", //电梯
                indoorToilet: "", //室内厕所
                indoorBathEquipment: "", //室内助浴设备
                buildingStructure: "", //房屋建筑结构
                residentialFloor: "", //居住楼层
                balconyPhoto: "", //阳台
                bedroomPhoto: "", //卧室
                kitchenPhoto: "", //厨房
                livingRoomPhoto: "", //客厅
                toiletPhoto: "", //卫生间
                assessApprovalStatus: 1, //审核状态
                assessApprovalReasons: "", //原因
                assessAbandonReasons: "", //放弃原因
                assessAbandonEnclosure: "", //放弃证明
                elderlySubProManageList: [], //清单列表
                currentApprovalStatus: "",
                assessResult: "",
                intelligence: "",
                shower: "",
                walking: "",
                toilet: "",
                dressing: "",
                eat: "",
                bed: "",
            },
            assessmentTable: [
                {
                    productName: "改造项目", //改造项目
                    name: "产品名称", //产品名称
                    count: "数量", //数量
                    unit: "单价", //单价
                    price: "费用", //费用
                },
                {
                    productName: "改造项目", //改造项目
                    name: "产品名称", //产品名称
                    count: "数量", //数量
                    unit: "单价", //单价
                    price: "费用", //费用
                },
            ],
            checkForm: {
                //施工督查表单
                assessConfirmation: "", //评估单
                // straightArmrestBefore: "", //扶手改造前
                // straightArmrestAfter: "", //扶手改造后
                // smokeDetectorBefore: "", //烟雾报警器改造前
                // smokeDetectorAfter: "", //烟雾报警器改造后
                elderlySubProManageList: [],
                constructionAbandonReasons: "", //放弃原因
                constructionAbandonEnclosure: "", //放弃证明
                constructionApprovalStatus: 1, //审核状态
                constructionApprovalReasons: "", //原因
                currentApprovalStatus: "",
                balconyPhoto: "", //阳台改造前
                bedroomPhoto: "", //卧室改造前
                kitchenPhoto: "", //厨房改造前
                livingRoomPhoto: "", //客厅改造前
                toiletPhoto: "", //卫生间改造前
                balconyAfterPhoto: "", //阳台改造后
                bedroomAfterPhoto: "", //卧室改造后
                kitchenAfterPhoto: "", //厨房改造后
                livingRoomAfterPhoto: "", //客厅改造后
                toiletAfterPhoto: "", //卫生间改造后
            },

            evaluateForm: {
                //评价表单
                assessType: "", //评价方式
                selectDeptId: "", //选择部门
                selectPersonId: "", //选择人员
            },
            evaluateFormRules: {
                //评价表单验证规则
                assessType: [
                    {
                        required: true,
                        message: "评价方式不能为空",
                        trigger: "blur",
                    },
                ], //评价方式
                selectDeptId: [
                    {
                        required: true,
                        message: "部门不能为空",
                        trigger: "blur",
                    },
                ], //选择部门
                selectPersonId: [
                    {
                        required: true,
                        message: "人员不能为空",
                        trigger: "blur",
                    },
                ], //选择人员
            },
            evaluateTypetList: [], //评价类型列表
            chooseDepartmentList: [], //选择部门列表
            evaluateTypeList: [], //类型问题列表
            choosePersonnelList: [], //选择人员列表
            returnVisitForm: {
                //回访工单表单
                file: "", //附件
            },
            endForm: {
                //结束表单
                problemOne: "", //回复一
                replyChooseOne: "", //回复选择一
                problemTwo: "", //回复二
                replyChooseTwo: "", //回复选择二
                other: "", //其他
                file: "", //附件
                cases: "0",
            },
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
            provinceList: [], //省列表
            cityList: [], //市列表
            areaList: [], //区列表
            streetList: [], //街道列表
            communityList: [], //社区列表
            shequList: [],
            list: [],
            myMap: null, //地图
            setUpDialogForm: {
                typeName: "", //类型名称
                publishPlatform: "0",
                evaluateContentList: [],
            },
            approvalStatuss: "",
            polygons: [],
            polygon: [],
            isMap: true,
            currentRow: {},
            medicalHistoryList: [
                //病史列表
                {
                    id: "0",
                    laebl: "健康",
                },
                {
                    id: "1",
                    laebl: "高血压",
                },
                {
                    id: "2",
                    laebl: "糖尿病",
                },
                {
                    id: "3",
                    laebl: "冠心病",
                },
                {
                    id: "4",
                    laebl: "恶性肿瘤",
                },
                {
                    id: "5",
                    laebl: "结核病",
                },
                {
                    id: "6",
                    laebl: "肝炎",
                },
                {
                    id: "7",
                    laebl: "脑卒中",
                },
                {
                    id: "8",
                    laebl: "精神疾病",
                },
                {
                    id: "9",
                    laebl: "慢性阻塞性肺疾病",
                },
                {
                    id: "10",
                    laebl: "慢性支气管炎",
                },
                {
                    id: "11",
                    laebl: "脑血栓",
                },
                {
                    id: "12",
                    laebl: "帕金森综合症",
                },
                {
                    id: "13",
                    laebl: "腰椎间盘突出",
                },
                {
                    id: "14",
                    laebl: "心脏病",
                },
                {
                    id: "15",
                    laebl: "肺气肿",
                },
                {
                    id: "16",
                    laebl: "风湿病",
                },
                {
                    id: "17",
                    laebl: "脑中风",
                },
                {
                    id: "18",
                    laebl: "高脂血症",
                },
                {
                    id: "19",
                    laebl: "哮喘",
                },
                {
                    id: "20",
                    laebl: "意外伤害",
                },
                {
                    id: "21",
                    laebl: "其他",
                },
            ],
            elderlyTypeList: [
                //老人自理类别列表
                {
                    id: 0,
                    label: "自理",
                },
                {
                    id: 1,
                    label: "失能",
                },
                {
                    id: 2,
                    label: "半失能",
                },
                {
                    id: 3,
                    label: "失智",
                },
                {
                    id: 4,
                    label: "轻度依赖",
                },
                {
                    id: 5,
                    label: "重度依赖",
                },
                {
                    id: 6,
                    label: "不能自理",
                },
            ],
            total: 0,
            AddDialogType: "", //评价设置table当前操作按钮title
            AddDialogRow: {}, //评价设置table当前行内容
            returnVisitList: [], //回访问题列表
            elderlyInformationList: [], //完工列表list
            isStepsfzc: "2",
            isSteps: "",
            infoList: [],
            marker: null,
            tableApprovalStatus: "",
            approvalStatusList: {
                0: "未分配",
                1: "待评估",
                2: "评估审核通过",
                3: "评估审核未通过",
                4: "施工督查审核通过",
                5: "施工督查未通过",
                6: "待回访",
                7: "回访完成",
                8: "完工",
                9: "app评估完成",
                10: "app评估放弃",
                11: "app施工完成",
                12: "app施工放弃",
            },
            currentStepIndex: 0,
            normalInfo: {},
            changeImg: true,
            imgList: [],
            showImgList: false,
            imgIndex: 0,
            listTitle: "",
        }
    },
    components: {
        globalTag,
        vueQr,
    },

    computed: {
        detailTatol() {
            let tatol = 0
            this.assessmentForm.elderlySubProManageList.forEach((item) => {
                if (!!item && !!item.price) {
                    tatol += Number(item.price)
                }
            })
            return tatol
        },
    },

    methods: {
        getssOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: {
                        isValid: 1,
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (res.code == 200 && res.content) {
                        let item = this.chbehavior(
                            res.content,
                            this.$store.state.info.orgId
                        )
                        this.ssorgList.push(item)
                        // console.log(this.orgList)
                    }
                })
        },
        chbehavior(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        setDataName(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a.label
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        checkMobile() {
            if (this.formData.phone != "") {
                let validatePhone = /^1[0-9]{10}$/
                if (this.dialogVisibleTitle == "编辑") {
                    if (!validatePhone.test(this.formData.phone)) {
                        this.$message.error("手机号格式错误")
                    }
                } else if (this.dialogVisibleTitle == "编辑") {
                    if (!validatePhone.test(this.formDataEdit.phone)) {
                        this.$message.error("手机号格式错误")
                    }
                }
            }
        },
        getchangeList(query, query1) {
            this.$http
                .request({
                    url: "/ypt/admin/all/customer/info/findListAccurately",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: -1,
                        customerName: query,
                        idCard: query1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content != null) {
                            this.options = res.content.list
                        } else {
                            this.options = []
                        }
                        this.loading = false
                    }
                })
        },
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList(query, "")
            } else {
                this.options = []
            }
        },
        remoteMethod1(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList("", query)
            } else {
                this.options = []
            }
        },
        async handleSelect(val) {
            this.options.forEach(async (item) => {
                if (item.id == val) {
                    // this.formData = JSON.parse(JSON.stringify(item))
                    // console.log(item)
                    this.formData.oldId = val
                    this.formData.idCard = JSON.parse(
                        JSON.stringify(item)
                    ).idCard
                    this.$set(this.formData, "gender", item.gender)
                    this.$set(this.formData, "phone", item.phone)
                    this.$set(this.formData, "age", item.age)
                    this.$set(this.formData, "familyCall", item.familyCall)
                    this.$set(this.formData, "photo", item.photo)
                    this.$set(this.formData, "dataId", item.dataId)
                    this.$set(
                        this.formData,
                        "elderlyBelongCategory",
                        item.elderlyBelongCategory
                    )
                    this.$set(this.formData, "provinceId", item.provinceId)
                    this.$set(this.formData, "cityId", item.cityId)
                    this.$set(this.formData, "areaId", item.areaId)
                    this.$set(this.formData, "streetId", item.streetId)
                    this.$set(this.formData, "communityId", item.communityId)
                    this.$set(this.formData, "address", item.address)
                    this.$set(this.formData, "longitude", item.longitude)
                    this.$set(this.formData, "latitude", item.latitude)

                    if (this.formData.elderlyBelongCategory != null) {
                        this.formData.elderlyBelongCategory =
                            this.formData.elderlyBelongCategory.toString()
                    }

                    if (
                        this.formData.provinceId == null ||
                        this.formData.provinceId == "0"
                    ) {
                        this.formData.provinceId = ""
                        return
                    }
                    if (
                        this.formData.cityId == null ||
                        this.formData.cityId == "0"
                    ) {
                        this.formData.cityId = ""
                        return
                    }
                    if (
                        this.formData.areaId == null ||
                        this.formData.areaId == "0"
                    ) {
                        this.formData.areaId = ""
                        return
                    }
                    if (
                        this.formData.streetId == null ||
                        this.formData.streetId == "0"
                    ) {
                        this.formData.streetId = ""
                        return
                    }
                    if (
                        this.formData.communityId == null ||
                        this.formData.communityId == "0"
                    ) {
                        this.formData.communityId = ""
                        return
                    }
                    let provice = await this.getDistricts()
                    this.provinceList = provice.districtList
                    this.formData.provinceId = String(this.formData.provinceId)
                    if (!this.formData.provinceId) return
                    let city = await this.getDistricts(this.formData.provinceId)
                    this.cityList = city.districtList
                    if (!this.formData.cityId) return
                    this.formData.cityId = String(this.formData.cityId)
                    let area = await this.getDistricts(this.formData.cityId)
                    this.areaList = area.districtList
                    if (!this.formData.areaId) return
                    this.formData.areaId = String(this.formData.areaId)
                    let streetList = await this.getStreetList(
                        this.formData.areaId
                    )
                    this.streetList = streetList
                    if (!this.formData.streetId) return
                    this.formData.streetId = String(this.formData.streetId)
                    let communityList = await this.getCommityList(
                        this.formData.streetId
                    )
                    this.communityList = communityList
                    this.formData.communityId = Number(
                        this.formData.communityId
                    ) //社区

                    this.loadmap("container")
                    setTimeout(() => {
                        this.potintMap()
                    }, 500)
                    this.$forceUpdate()
                }
            })
        },
        //监控姓名是否为空
        clearForm(val) {
            if (val) {
                if (this.dialogVisibleTitle == "新增") {
                    this.formData = {}
                }
            }
        },
        //监控身份证是否为空
        clearForm1(val) {
            if (val) {
                if (this.dialogVisibleTitle == "新增") {
                    this.formData = {}
                }
            }
        },
        gettypeList() {
            let query = {
                pageNum: 1,
                pageSize: 999,
                dictType: "customer.type",
            }
            this.$http
                .request({
                    url: "/rbac/system/dict/data/list",
                    method: "get",
                    params: query,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.rows != null) {
                            this.oldtypeLits = res.rows
                            this.oldtypeLits.forEach((item) => {
                                item.dictCode = String(item.dictCode)
                            })
                        }
                    }
                })
        },
        // 输入地址
        getMap(input) {
            const self = this
            const autoOptions = {
                city: this.formData.areaId,
                citylimit: true,
                input: input,
            }
            // alert(input)
            const auto = new AMap.Autocomplete(autoOptions)
            //构造地点查询类
            AMap.event.addListener(auto, "select", (e) => {
                self.formData.address = e.poi.name
                self.formData.longitude = e.poi.location.lng
                self.formData.latitude = e.poi.location.lat
                self.potintMap()
            })
        },
        getMap1(input) {
            const self = this
            const autoOptions = {
                city: this.formDataEdit.areaId,
                citylimit: true,
                input: input,
            }
            // alert(input)
            const auto = new AMap.Autocomplete(autoOptions)
            //构造地点查询类
            AMap.event.addListener(auto, "select", (e) => {
                self.formDataEdit.address = e.poi.name
                self.formDataEdit.longitude = e.poi.location.lng
                self.formDataEdit.latitude = e.poi.location.lat
                self.potintMap1()
            })
        },
        // //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/findOrgById",
                    method: "POST",
                    data: { id: this.$store.state.info.orgId },
                })
                .then((res) => {
                    if (res.code == 200) {
                        // this.getProvince()
                        this.normalInfo = res.content
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        async changeFirst() {
            let provice = await this.getDistricts()
            this.provinceList = provice.districtList
            if (this.normalInfo.provinceId == 0) {
                this.normalInfo.provinceId = ""
            } else {
                this.normalInfo.provinceId = String(this.normalInfo.provinceId)
                let cityList = await this.getDistricts(
                    this.normalInfo.provinceId
                )
                this.cityList = cityList.districtList
            }
            if (this.normalInfo.cityId) {
                this.normalInfo.cityId = String(this.normalInfo.cityId)
                let areaList = await this.getDistricts(this.normalInfo.cityId)
                this.areaList = areaList.districtList
            } else {
                this.normalInfo.cityId = ""
            }

            if (this.normalInfo.areaId) {
                this.normalInfo.areaId = String(this.normalInfo.areaId)
                // let streetList = await this.getDistricts(this.normalInfo.areaId)
                let streetList = await this.getStreetList(
                    this.normalInfo.areaId
                )
                this.streetList = streetList
            } else {
                this.normalInfo.areaId = ""
            }
            if (this.normalInfo.streetId) {
                this.normalInfo.streetId = String(this.normalInfo.streetId)
                let communityList = await this.getCommityList(
                    this.normalInfo.streetId
                )
                this.communityList = communityList
            } else {
                this.normalInfo.streetId = ""
            }
            if (
                this.normalInfo.orgLevel == 1 ||
                this.normalInfo.orgLevel == 0
            ) {
                this.provinceList.forEach((item) => {
                    if (item.adcode == this.normalInfo.provinceId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 2) {
                this.cityList.forEach((item) => {
                    if (item.adcode == this.normalInfo.cityId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (this.normalInfo.orgLevel == 3) {
                this.areaList.forEach((item) => {
                    if (item.adcode == this.normalInfo.areaId) {
                        this.formData.latitude = item.center.lat
                        this.formData.longitude = item.center.lng
                    }
                })
            } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
            ) {
                this.streetList.forEach((item, index) => {
                    if (item.addCode == this.normalInfo.streetId) {
                        this.formData.latitude = item.latitude
                        this.formData.longitude = item.longitude
                    }
                })
            }
            // /this.potintMap()

            if (this.normalInfo.communityId) {
                this.normalInfo.communityId = Number(
                    this.normalInfo.communityId
                )
            } else {
                this.normalInfo.communityId = ""
            }
            //搜索栏
            this.form.provinceId = this.normalInfo.provinceId
            this.form.cityid = this.normalInfo.cityId
            this.form.zoneid = this.normalInfo.areaId
            this.form.streetid = this.normalInfo.streetId
            this.form.shequid = this.normalInfo.communityId
            //
            this.formData.provinceId = this.normalInfo.provinceId
            this.formData.cityId = this.normalInfo.cityId
            this.formData.areaId = this.normalInfo.areaId
            this.formData.streetId = this.normalInfo.streetId
            this.formData.communityId = this.normalInfo.communityId
            this.loadmap("container")
            setTimeout(() => {
                this.potintMap()
            }, 500)
            this.$forceUpdate()
        },
        //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {})
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.shequList = res.content
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {})
        },
        //街道地址发生变化
        async streetChange(val) {
            let communityList = await this.getCommityList(val)
            this.communityList = communityList
            //this.joinAddress()
        },
        handleCommunityChange(val) {
            this.$nextTick(() => {
                this.$forceUpdate()
                // this.joinAddress()
            })
        },

        // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {}
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(self.formData.longitude),
                    Number(self.formData.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        potintMap1() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {}
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(self.formDataEdit.longitude),
                    Number(self.formDataEdit.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        // 获取省市区
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {}

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                    }
                })
            }).catch((err) => {})
        },
        //点击编辑
        async handleTableEdit(title, index, row = {}) {
            this.stepIndex = 1
            this.isStepsfzc = 2
            let self = this
            self.currentRow = row
            this.setUpDialogDeit = true

            self.formDataEdit = self.currentRow
            let temp = JSON.stringify(row)
            let jsonTemp = JSON.parse(temp)
            jsonTemp.provinceId &&
                (jsonTemp.provinceId = String(jsonTemp.provinceId))
            jsonTemp.cityId && (jsonTemp.cityId = String(jsonTemp.cityId))
            jsonTemp.areaId && (jsonTemp.areaId = String(jsonTemp.areaId))
            jsonTemp.streetId && (jsonTemp.streetId = String(jsonTemp.streetId))
            self.formDataEdit.dataId = jsonTemp.dataId
            self.formDataEdit.photo = jsonTemp.photo
            self.formDataEdit.cusId = jsonTemp.oldId
            self.formDataEdit.oldId = jsonTemp.customerName
            self.formDataEdit.customerName = jsonTemp.customerName //姓名
            self.formDataEdit.gender = jsonTemp.gender //性别
            self.formDataEdit.phone = jsonTemp.phone //联系方式
            self.formDataEdit.idCard = jsonTemp.idCard //身份证号
            self.formDataEdit.age = jsonTemp.age //年龄
            self.formDataEdit.elderlyBelongCategory =
                jsonTemp.elderlyBelongCategory //老人类型
            self.formDataEdit.provinceId = jsonTemp.provinceId //省
            self.formDataEdit.cityId = jsonTemp.cityId //市
            self.formDataEdit.areaId = jsonTemp.areaId //区
            self.formDataEdit.streetId = jsonTemp.streetId //街道
            self.formDataEdit.communityId = Number(jsonTemp.communityId) //社区
            self.formDataEdit.street = jsonTemp.street //街道
            self.formDataEdit.community = jsonTemp.community //社区
            self.formDataEdit.address = jsonTemp.address //居住地址
            self.formDataEdit.orgId = jsonTemp.orgId
            self.formDataEdit.orgName = jsonTemp.orgName
            this.imageUrl = jsonTemp.photo
            if (!jsonTemp.provinceId) return
            let city = await self.getDistrict(jsonTemp.provinceId)
            self.cityList = city.districtList
            if (!jsonTemp.cityId) return
            let area = await self.getDistrict(jsonTemp.cityId)
            self.areaList = area.districtList
            if (!jsonTemp.areaId) return
            // let street = await self.getDistrict(jsonTemp.areaId)
            let streetList = await this.getStreetList(jsonTemp.areaId)
            self.streetList = streetList
            if (!jsonTemp.streetId) return
            let communityList = await this.getCommityList(jsonTemp.streetId)
            self.communityList = communityList
            setTimeout(async () => {
                await self.$nextTick(() => {
                    self.loadmap("container2")
                    self.potintMap1()
                })
            }, 30)
            this.$forceUpdate()
        },
        loopNode(node, arr) {
            if (node.parent == null) {
                return arr
            } else {
                arr.push(node.data.orgId)
                this.loopNode(node.parent, arr)
            }
        },
        handleEditNodeClick(data, node) {
            const clickNode = this.$refs.tree.getNode(node)
            const arr = []
            this.loopNode(clickNode, arr)
            this.arrOrgList = arr
            let obj = common.organization(
                this.arrOrgList,
                this.normalInfo.orgLevels
            )
            this.$set(this.formData, "orgId", data.orgId)
            this.$set(this.formData, "parentId", data.parentId)
            this.$set(this.formData, "orgType", data.orgType)
            this.$set(this.formData, "orgName", data.label)
            this.$set(this.formData, "qujiId", obj.qujiId)
            this.$set(this.formData, "shengjiId", obj.shengjiId)
            this.$set(this.formData, "shijiId", obj.shijiId)
            this.$set(this.formData, "stationId", obj.stationId)
            this.$set(this.formData, "shequjiId", obj.shequjiId)
            this.$refs["selectBoxRef"].handleClose()
        },
        changeProject() {
            this.$nextTick(() => {
                document.querySelectorAll(".change_project").forEach((el) => {
                    el.querySelectorAll(".el-checkbox").forEach((child) => {
                        let isImg = child.querySelector("img")
                        if (isImg) {
                            child.removeChild(isImg)
                        }
                    })
                })
                document.querySelectorAll(".change_project").forEach((el) => {
                    el.querySelectorAll(".el-checkbox").forEach((child) => {
                        let classLsit = [...child.classList]
                        if (classLsit.includes("is-checked")) {
                            let img = document.createElement("img")
                            img.src = require("../assets/img/duihao.png")
                            img.style =
                                "width: 10px;position: absolute;left: 2px;top: 4px;z-index: 100"
                            child.appendChild(img)
                        }
                    })
                })
            })
        },
        //s
        //获取老人信息
        handleGetById(id) {
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/getById",
                    method: "POST",
                    data: {
                        id: id,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        let data = res.content
                        if (
                            data.projectId === "" ||
                            data.projectId === null ||
                            data.projectId === undefined
                        ) {
                            return
                        }
                        self.distributionForm.projectId = data.projectId
                        self.distributionForm.serviceProviderId =
                            data.serviceProviderId
                        if (
                            data.serviceProviderId === "" ||
                            data.serviceProviderId === null ||
                            data.serviceProviderId === undefined
                        ) {
                            return
                        }
                        if (this.dialogVisibleTitle == "查看") {
                            this.distributionForm.projectId = data.projectName
                            this.distributionForm.serviceid =
                                this.distributionForm.serviceProviderId
                            this.distributionForm.serviceProviderId =
                                data.serviceProviderName
                        }
                        self.getServiceProviderPerson(
                            self.distributionForm.serviceid
                        )
                        self.distributionForm.leader = data.leader
                        self.distributionForm.serviceProviderPersonId =
                            data.serviceProviderPersonId.split(",")
                    }
                })
        },
        changeId(val) {
            // tempArr.serviceProviderPersonId.forEach(
            //     (item, index) => {
            //       tempArr.serviceProviderPersonId[
            //         index
            //         ] = this.providerPersonList[index].id
            //     }
        },
        //获取老人信息
        handleAssessTypeGetById(id) {
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/getById",
                    method: "POST",
                    data: {
                        id: id,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        let data = res.content
                        self.evaluateForm.assessType = Number(data.assessType) //评价方式
                        self.evaluateTypeChange(self.evaluateForm.assessType)
                        self.evaluateForm.selectDeptId = data.selectDeptId //选择部门
                        self.chooseDepartmentChange(
                            self.evaluateForm.selectDeptId
                        )
                        self.evaluateForm.selectPersonId = data.selectPersonId //选择人员
                        self.evaluateForm.publishPlatform = data.publishPlatform
                        // self.evaluateTypeList = []
                        //  self.distributionForm.serviceProviderId=String(data.serviceProviderId)
                    }
                })
        },
        async handleStep(index) {
            let self = this
            this.stepIndex = index
            switch (index) {
                case 1:
                    let temp = JSON.stringify(this.currentRow)
                    let jsonTemp = JSON.parse(temp)
                    // jsonTemp.gender == "男"
                    //     ? (jsonTemp.gender = "0")
                    //     : (jsonTemp.gender = "1")
                    jsonTemp.provinceId &&
                        (jsonTemp.provinceId = String(jsonTemp.provinceId))
                    jsonTemp.cityId &&
                        (jsonTemp.cityId = String(jsonTemp.cityId))
                    jsonTemp.areaId &&
                        (jsonTemp.areaId = String(jsonTemp.areaId))
                    jsonTemp.streetId &&
                        (jsonTemp.streetId = String(jsonTemp.streetId))
                    self.formData.photo = jsonTemp.photo
                    self.formData.name = jsonTemp.name //姓名
                    self.formData.cusId = jsonTemp.oldId
                    self.formData.oldId = jsonTemp.customerName
                    self.formData.gender = jsonTemp.gender //性别
                    self.formData.phone = jsonTemp.phone //联系方式
                    self.formData.idCard = jsonTemp.idCard //身份证号
                    self.formData.age = jsonTemp.age //年龄
                    self.formData.elderlyBelongCategory =
                        jsonTemp.elderlyBelongCategory //老人类型
                    self.formData.provinceId = jsonTemp.provinceId //省
                    self.formData.cityId = jsonTemp.cityId //市
                    self.formData.areaId = jsonTemp.areaId //区
                    self.formData.streetId = jsonTemp.streetId //街道
                    self.formData.communityId = Number(jsonTemp.communityId) //社区
                    self.formData.street = jsonTemp.street //街道
                    self.formData.community = jsonTemp.community //社区
                    self.formData.address = jsonTemp.address //居住地址
                    this.imageUrl = jsonTemp.photo
                    if (!jsonTemp.provinceId) return
                    let city = await self.getDistrict(jsonTemp.provinceId)
                    self.cityList = city.districtList
                    if (!jsonTemp.cityId) return
                    let area = await self.getDistrict(jsonTemp.cityId)
                    self.areaList = area.districtList
                    if (!jsonTemp.areaId) return
                    // let street = await self.getDistrict(jsonTemp.areaId)
                    let streetList = await this.getStreetList(jsonTemp.areaId)
                    self.streetList = streetList
                    if (!jsonTemp.streetId) return
                    let communityList = await this.getCommityList(
                        jsonTemp.streetId
                    )
                    self.communityList = communityList
                    if (!jsonTemp.communityId) return
                    break
                case 2:
                    self.distributionForm.serviceProviderPersonId = []
                    self.providerPersonList = []
                    self.handleGetById(this.currentRow.id)
                    break
                case 3:
                case 4:
                    self.getById(this.currentRow)
                    break
                case 5:
                    self.getEvaluateTypeInfo()
                    self.getDeptManage()
                    self.handleAssessTypeGetById(this.currentRow.id)
                    break
                case 6:
                    this.getReturnVisit()
                    break
                case 7:
                    self.$http
                        .request({
                            url: "/jjyl/admin/elderlyInformation/info/getById",
                            method: "POST",
                            data: {
                                id: self.currentRow.id,
                            },
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                if (
                                    res.content.cases !== null &&
                                    res.content.cases !== "" &&
                                    res.content.cases !== undefined
                                ) {
                                    self.endForm.cases = res.content.cases
                                }
                            }
                        })
                    this.getElderlyInformation(this.currentRow.id)
                    break
            }
        },
        handleStepsIndex(row) {
            if (this.currentRow.finishedButtonFlag == 1) {
                //完工按钮标志
                this.isSteps = 9
                this.stepIndexStatus = 7
                return
            }
            if (this.currentRow.returnVisitButtonFlag == 1) {
                //回访工单按钮标志
                this.stepIndexStatus = 6
                this.isSteps = 8
                return
            }
            if (this.currentRow.evaluateButtonFlag == 1) {
                //评价按钮标志
                this.stepIndexStatus = 5
                this.isSteps = 7
                return
            }
            if (this.currentRow.constructionAbandonButtonFlag == 1) {
                //施工审核按钮放弃标志
                this.stepIndexStatus = 4
                this.isSteps = 6
                return
            }
            if (this.currentRow.constructionButtonFlag == 1) {
                //施工审核按钮标志
                this.stepIndexStatus = 4
                this.isSteps = 5
                return
            }
            if (this.currentRow.printButtonFlag == 1) {
                //打印按钮标志
                this.stepIndexStatus = 3
                this.isSteps = 4
                return
            }
            if (this.currentRow.assessAbandonButtonFlag == 1) {
                //评估审核放弃按钮标志
                this.stepIndexStatus = 3
                this.isSteps = 3
                return
            }
            if (this.currentRow.assessButtonFlag == 1) {
                //评估审核按钮标志
                this.stepIndexStatus = 3
                this.isSteps = 2
                return
            }
            if (this.currentRow.distributeButtonFlag == 1) {
                //分配按钮标志
                this.stepIndexStatus = 2
                this.isSteps = 1
                return
            }
            this.stepIndexStatus = 10
            this.isSteps = 10
            if (row.approvalStatus == 3) {
                this.isSteps = 2
            }
            if (row.approvalStatus == 5) {
                this.isSteps = 5
            }
        },
        //处理table表格表单
        async handleTableForm(title, index, row = {}) {
            this.isdisabled = false
            this.isStepsfzc = 2
            let self = this
            self.dialogVisibleTitle = title
            self.dialogVisible = true
            self.stepIndex = index
            self.currentStepIndex = index
            self.currentRow = row
            self.datasid = row.dataId
            self.handleStepsIndex(row)
            switch (self.stepIndex) {
                case 0:
                    self.imageUrl = ""
                    self.formData.photo = ""
                    self.formData.name = "" //姓名
                    self.formData.gender = "" //性别
                    self.formData.phone = "" //联系方式
                    self.formData.idCard = "" //身份证号
                    self.formData.age = "" //年龄
                    self.formData.elderlyBelongCategory = "" //老人类型
                    self.formData.provinceId = "" //省
                    self.formData.cityId = "" //市
                    self.formData.areaId = "" //区
                    self.formData.streetId = ""
                    self.formData.street = "" //街道
                    self.formData.community = "" //社区
                    self.formData.communityId = "" //社区
                    self.formData.address = "" //居住地址
                    self.formData.orgId = "" //机构id
                    self.streetList = []
                    self.$nextTick(() => {
                        self.loadmap("container")
                        // self.potintMap()
                    })
                    break
                case 1:
                    // console.log(row)
                    let temp = JSON.stringify(row)
                    let jsonTemp = JSON.parse(temp)
                    jsonTemp.provinceId &&
                        (jsonTemp.provinceId = String(jsonTemp.provinceId))
                    jsonTemp.cityId &&
                        (jsonTemp.cityId = String(jsonTemp.cityId))
                    jsonTemp.areaId &&
                        (jsonTemp.areaId = String(jsonTemp.areaId))
                    jsonTemp.streetId &&
                        (jsonTemp.streetId = String(jsonTemp.streetId))
                    self.formData.photo = jsonTemp.photo
                    self.formData.cusId = jsonTemp.oldId
                    self.formData.oldId = jsonTemp.customerName
                    self.formData.customerName = jsonTemp.customerName //姓名
                    self.formData.gender = jsonTemp.gender //性别
                    self.formData.phone = jsonTemp.phone //联系方式
                    self.formData.idCard = jsonTemp.idCard //身份证号
                    self.formData.age = jsonTemp.age //年龄
                    self.formData.elderlyBelongCategory =
                        jsonTemp.elderlyBelongCategory //老人类型
                    self.formData.provinceId = jsonTemp.provinceId //省
                    self.formData.cityId = jsonTemp.cityId //市
                    self.formData.areaId = jsonTemp.areaId //区
                    self.formData.streetId = jsonTemp.streetId //街道
                    self.formData.communityId = Number(jsonTemp.communityId) //社区
                    //  self.formData.communityId = Number(jsonTemp.communityId)
                    self.formData.street = jsonTemp.street //街道
                    self.formData.community = jsonTemp.community //社区
                    self.formData.address = jsonTemp.address //居住地址
                    self.formData.orgId = jsonTemp.orgId
                    self.formData.orgName = jsonTemp.orgName
                    self.formData.dataId = jsonTemp.dataId

                    this.imageUrl = jsonTemp.photo
                    if (!jsonTemp.provinceId) return
                    let city = await self.getDistrict(jsonTemp.provinceId)
                    self.cityList = city.districtList
                    if (!jsonTemp.cityId) return
                    let area = await self.getDistrict(jsonTemp.cityId)
                    self.areaList = area.districtList
                    if (!jsonTemp.areaId) return
                    // let street = await self.getDistrict(jsonTemp.areaId)
                    let streetList = await this.getStreetList(jsonTemp.areaId)
                    self.streetList = streetList
                    if (!jsonTemp.streetId) return
                    let communityList = await this.getCommityList(
                        jsonTemp.streetId
                    )
                    self.communityList = communityList
                    this.formData.longitude = row.longitude
                    this.formData.latitude = row.latitude
                    setTimeout(async () => {
                        await self.$nextTick(() => {
                            self.loadmap("container")
                            self.potintMap()
                        })
                    }, 30)
                    // console.log(title, self.currentRow.approvalStatus)
                    if (
                        title == "编辑" &&
                        self.currentRow.approvalStatus == 8
                    ) {
                        this.changeImg = false
                        if (row.balconyPhoto) {
                            this.imgforms.balconyPhotoShows =
                                row.balconyPhoto.split("#")
                        } else {
                            this.imgforms.balconyPhotoShows = []
                        }
                        if (row.balconyAfterPhoto) {
                            this.imgforms.balconyAfterPhotoShows =
                                row.balconyAfterPhoto.split("#")
                        } else {
                            this.imgforms.balconyAfterPhotoShows = []
                        }
                        if (row.toiletAfterPhoto) {
                            this.imgforms.toiletAfterPhotoShows =
                                row.toiletAfterPhoto.split("#")
                        } else {
                            this.imgforms.toiletAfterPhotoShows = []
                        }
                        if (row.toiletPhoto) {
                            this.imgforms.toiletPhotoShows =
                                row.toiletPhoto.split("#")
                        } else {
                            this.imgforms.toiletPhotoShows = []
                        }
                        if (row.livingRoomPhoto) {
                            this.imgforms.livingRoomPhotoShows =
                                row.livingRoomPhoto.split("#")
                        } else {
                            this.imgforms.livingRoomPhotoShows = []
                        }
                        if (row.livingRoomAfterPhoto) {
                            this.imgforms.livingRoomAfterPhotoShows =
                                row.livingRoomAfterPhoto.split("#")
                        } else {
                            this.imgforms.livingRoomAfterPhotoShows = []
                        }

                        if (row.kitchenPhoto) {
                            this.imgforms.kitchenPhotoShows =
                                row.kitchenPhoto.split("#")
                        } else {
                            this.imgforms.kitchenPhotoShows = []
                        }
                        if (row.kitchenAfterPhoto) {
                            this.imgforms.kitchenAfterPhotoShows =
                                row.kitchenAfterPhoto.split("#")
                        } else {
                            this.imgforms.kitchenAfterPhotoShows = []
                        }
                        if (row.bedroomPhoto) {
                            this.imgforms.bedroomPhotoShows =
                                row.bedroomPhoto.split("#")
                        } else {
                            this.imgforms.bedroomPhotoShows = []
                        }
                        if (row.bedroomAfterPhoto) {
                            this.imgforms.bedroomAfterPhotoShows =
                                row.bedroomAfterPhoto.split("#")
                        } else {
                            this.imgforms.bedroomAfterPhotoShows = []
                        }
                    } else {
                        this.changeImg = true
                    }
                    this.$forceUpdate()
                    break
                case 2:
                    self.getProjectManage()
                    self.getServiceProvider(row.dataId)
                    break
                case 3:
                case 4:
                    self.getById(row)
                    break
                case 5:
                    self.getEvaluateTypeInfo()
                    self.getDeptManage()
                    break
                case 6:
                    this.getReturnVisit()
                    break
                case 7:
                    this.getElderlyInformation(row.id)
                    break
            }
        },
        handlePrint() {
            this.$print(this.$refs.print)
        },
        printDialogVisibleClose() {
            this.printForm.customerName = "" //姓名
            this.printForm.idCard = "" //身份证号
            this.printForm.phone = "" //联系方式
            this.printForm.modificationAddress = "" //改造地址
            this.printForm.assessmentProject = [] //
            this.printForm.assessmentProjectResult = []
            this.printForm.familyMembersAssess = [] //家庭成员评估
            this.printForm.elevator = [] //电梯
            this.printForm.indoorToilet = [] //室内厕所
            this.printForm.indoorBathEquipment = [] //室内助浴设备
            this.printForm.buildingStructure = [] //房屋建筑结构
            this.printForm.residentialFloor = [] //居住楼层
            this.printForm.elderlySubProManageList = [] //改造清单
            this.printForm.address = "" //改造地址
            this.printForm.shengName = "" //省名称
            this.printForm.shiName = "" //市名称
            this.printForm.quName = "" //区名称
            this.printForm.jiedaoName = "" //街道名称
            this.printForm.shequName = "" //社区名称
            this.printForm.assessResult = [] //评估结果
            this.printForm.intelligence = [] //智力
            this.printForm.shower = [] //洗澡
            this.printForm.walking = [] //室内走动
            this.printForm.toilet = [] //上厕所
            this.printForm.dressing = [] //穿衣
            this.printForm.eat = [] //吃饭
            this.printForm.bed = [] //上下床
        },
        // 删除按钮
        handleTableDelet(e) {
            let params = {
                id: e.id,
            }
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/jjyl/admin/elderlyInformation/info/deleteById",
                            method: "POST",
                            data: params,
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                this.reload()
                            } else {
                            }
                        })
                    this.$message.success("删除成功!")
                })
                .catch(() => {
                    this.$message.info("已取消删除")
                })
        },
        // 撤回按钮
        handleTableReturn(e) {
            let params = {
                id: e.id,
            }
            this.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/getById",
                    method: "POST",
                    data: {
                        id: e.id,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        let dataVL = res.content
                        if (
                            dataVL.saveStatus == "1" &&
                            dataVL.approvalStatus == "1"
                        ) {
                            this.$message({
                                type: "success",
                                message: "该分配已被保存，无法撤回!",
                            })
                        } else {
                            this.$confirm(
                                "此操作将撤回分配, 是否继续?",
                                "提示",
                                {
                                    confirmButtonText: "确定",
                                    cancelButtonText: "取消",
                                    type: "warning",
                                }
                            )
                                .then(() => {
                                    this.$http
                                        .request({
                                            url: "/jjyl/admin/elderlyInformation/info/returnStart",
                                            method: "POST",
                                            data: params,
                                        })
                                        .then((res) => {
                                            if (res.code === 200) {
                                                this.getElderlyInfoList()
                                            } else {
                                            }
                                        })
                                    this.$message.success("撤回分配成功!")
                                })
                                .catch(() => {
                                    this.$message.info("已取消撤回分配")
                                })
                        }
                    } else {
                    }
                })
        },
        // table打印按钮
        showPrintDialog(row) {
            this.printDialogVisible = true
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/getById",
                    method: "POST",
                    data: {
                        id: row.id,
                    },
                })
                .then(async (res) => {
                    if (res.code === 200) {
                        let data = res.content
                        this.printForm.customerName = data.customerName //姓名
                        this.printForm.idCard = data.idCard //身份证号
                        this.printForm.phone = data.phone //联系方式
                        this.printForm.address = data.address //改造地址
                        this.printForm.assessResult =
                            data.assessResult.split(",")
                        this.printForm.intelligence =
                            data.intelligence.split(",")
                        this.printForm.shower = data.shower.split(",")
                        this.printForm.walking = data.walking.split(",")
                        this.printForm.toilet = data.toilet.split(",")
                        this.printForm.dressing = data.dressing.split(",")
                        this.printForm.eat = data.eat.split(",")
                        this.printForm.bed = data.bed.split(",")
                        this.printForm.elderlySubProManageList =
                            data.elderlySubProManageList //清单列表
                        if (this.printForm.elderlySubProManageList) {
                            this.printForm.totalPrice = 0
                            this.printForm.elderlySubProManageList.forEach(
                                (item) => {
                                    this.printForm.totalPrice += item.price
                                }
                            )
                        }
                        this.printForm.familyMembersAssess =
                            data.familyMembersAssess.split(",") //家庭成员评估
                        this.printForm.elevator = data.elevator.split(",") //电梯
                        this.printForm.indoorToilet =
                            data.indoorToilet.split(",") //室内厕所
                        this.printForm.indoorBathEquipment =
                            data.indoorBathEquipment.split(",") //室内助浴设备
                        this.printForm.buildingStructure =
                            data.buildingStructure.split(",") //房屋建筑结构
                        this.printForm.residentialFloor =
                            data.residentialFloor.split(",") //居住楼层
                        if (!data.provinceId) return
                        let shiList = await self.getDistrictPrint(
                            String(data.provinceId)
                        )
                        let resultShi = shiList.districtList.find(
                            (item) => item.adcode == data.cityId
                        )
                        this.printForm.shiName = resultShi.name
                        if (!data.areaId) return
                        let jiedaoList = await self.getDistrictPrint(
                            String(data.areaId).replace(/.$/, "")
                        )
                        let resultJiedao = jiedaoList.districtList.find(
                            (item, index) =>
                                item.adcode + index == data.streetId
                        )
                        this.printForm.jiedaoName = resultJiedao.name
                        if (!data.streetId) return
                        this.$http
                            .request({
                                url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                                method: "POST",
                                data: {
                                    pageSize: 1000,
                                    pageNo: 1,
                                    parentId: data.streetId,
                                },
                            })
                            .then((res) => {
                                if (res.code === 200) {
                                    if (
                                        res.content == null ||
                                        res.content == "null"
                                    ) {
                                        return
                                    }
                                    try {
                                        let a = res.content.list.find(
                                            (item) =>
                                                item.id == data.communityId
                                        )
                                        this.printForm.shequName = a.addressName
                                    } catch (error) {
                                        this.printForm.shequName = ""
                                    }
                                }
                            })
                        this.changeProject()
                    }
                })
        },

        //批量分配
        batchFenpei() {
            var val = this.selectedData
            let abc = false
            if (val.length > 0) {
                for (var i = 0; i < val.length; i++) {
                    if (val[i].approvalStatus != "0") {
                        abc = true
                    }
                }
                if (abc) {
                    this.$confirm(
                        "存在已分配的条目，已分配的不会重新分配",
                        "提示",
                        {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        }
                    ).then(() => {
                        this.stepIndex = 2
                        this.isStepsfzc = 1
                        this.isdisabled = false
                        this.stepIndexStatus = 2
                        this.dialogVisible = true
                        this.dialogVisibleTitle = "分配"
                    })
                } else {
                    this.stepIndex = 2
                    this.isStepsfzc = 1
                    this.isdisabled = false
                    this.stepIndexStatus = 2
                    this.dialogVisible = true
                    this.dialogVisibleTitle = "分配"
                }
            } else {
                this.$confirm("请至少勾选一条老人信息。", "提示")
            }
        },
        batchClear() {
            var that = this
            var val = this.selectedData
            if (val.length > 0) {
                this.dialogVisible6 = true
            } else {
                this.$confirm("请选择要清除的项。", "提示")
            }
        },
        Clears() {
            this.dialogVisible6 = false
            this.isphone = []
        },
        saveClear() {
            var val = this.selectedData
            this.isphone.forEach((item) => {
                if (item == "清除手机号") {
                    if (val.length > 0) {
                        val.forEach(function (item, index) {
                            request({
                                url: "/jjyl/admin/elderlyInformation/info/updatePhone",
                                method: "POST",
                                data: { id: item.id },
                            }).then((res) => {
                                if (res.code == 200) {
                                    this.$message({
                                        type: "success",
                                        message: "清除成功!",
                                    })
                                }
                            })
                        })
                    }
                }
                if (item == "清除座机号") {
                    if (val.length > 0) {
                        val.forEach(function (item, index) {
                            request({
                                url: "/jjyl/admin/elderlyInformation/info/updateFamilyCall",
                                method: "POST",
                                data: { id: item.id },
                            }).then((res) => {
                                if (res.code == 200) {
                                    this.$message({
                                        type: "success",
                                        message: "清除成功!",
                                    })
                                }
                            })
                        })
                    }
                }
            })
            this.dialogVisible6 = false
            this.isphone = []
            this.getElderlyInfoList()
        },
        // 导出表格
        handleExcel() {
            this.request2({
                url: "/jjyl/admin/elderlyInformation/info/exportElderlyInformation",
                method: "POST",
                excel: true,
                data: {
                    name: this.username,
                    gender: this.gender,
                    idCard: this.idCard,
                    menuType: "elderlyInformation",
                },
                responseType: "blob",
            }).then((res) => {
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "老人信息.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
        },

        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //获取地址
        getDistrictPrint(name = "中国") {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                    }
                })
            })
        },
        //编辑弹框确认按钮
        addEvaluateTypeEdit() {
            this.setUpDialogDeit = false
        },
        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    const MarkerList = self.myMap
                        .getAllOverlays()
                        .filter((item) => item.CLASS_NAME === "AMap.Marker")
                    self.myMap.remove(MarkerList)
                    self.myMap.remove(self.marker)
                } catch (err) {}
                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                        if (bounds) {
                            self.myMap.remove(self.polygons)
                            self.polygons = []
                            for (let i = 0, l = bounds.length; i < l; i++) {
                                self.polygon = new AMap.Polygon({
                                    map: self.myMap,
                                    strokeWeight: 1,
                                    strokeColor: "#0091ea",
                                    fillColor: "#80d8ff",
                                    fillOpacity: 0.4,
                                    path: bounds[i],
                                })
                                self.polygons.push(self.polygon)
                                if (!params) {
                                    self.polygon.on("click", function (e) {
                                        let lnglat = e.lnglat
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition(lnglat)
                                        geocoder.getAddress(
                                            lnglat,
                                            function (status, result) {
                                                if (
                                                    status === "complete" &&
                                                    result.regeocode
                                                ) {
                                                    var address =
                                                        result.regeocode
                                                            .formattedAddress
                                                    self.formData.address =
                                                        address
                                                    self.formData.longitude =
                                                        lnglat.lng
                                                    self.formData.latitude =
                                                        lnglat.lat
                                                } else {
                                                    console.error(
                                                        "根据经纬度查询地址失败"
                                                    )
                                                }
                                            }
                                        )
                                    })

                                    self.myMap.add(self.polygons)

                                    self.myMap.add(self.marker)
                                    self.marker.setPosition([
                                        result.districtList[0].center.lng,
                                        result.districtList[0].center.lat,
                                    ])
                                    self.myMap.setFitView(self.marker)
                                    self.myMap.setZoom(11)
                                    self.myMap.setFitView() //地图自适应
                                } else {
                                    if (params.longitude && params.latitude) {
                                        self.myMap.add(self.marker)
                                        self.marker.setPosition([
                                            params.longitude,
                                            params.latitude,
                                        ])
                                        self.myMap.setFitView(self.marker)
                                        self.myMap.setZoom(11)
                                    }
                                }
                            }
                        }
                    }
                })
            }).catch((err) => {})
        },
        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []

            this.formDataEdit.cityId = ""
            this.formData.cityId = ""
            this.formData.areaId = ""
            this.formDataEdit.areaId = ""
            this.formData.streetId = ""
            this.formDataEdit.streetId = ""
            this.formData.communityId = ""
            this.formDataEdit.communityId = ""
            this.formData.address = ""
            this.formDataEdit.address = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.areaId = ""
            this.formData.streetId = ""
            this.formData.communityId = ""
            this.formData.address = ""
            this.formDataEdit.areaId = ""
            this.formDataEdit.streetId = ""
            this.formDataEdit.communityId = ""
            this.formDataEdit.address = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.formData.streetId = ""
            this.formData.communityId = ""
            this.formData.address = ""
            this.formDataEdit.streetId = ""
            this.formDataEdit.communityId = ""
            this.formDataEdit.address = ""
            // val = val.replace(/.$/, "");
            let streetList = await this.getStreetList(val)
            this.streetList = streetList
        },
        querySearch() {
            let params = {
                // name: s === true ? '' :  this.formData.name,
                // gender: s === true ? '' :  this.gender,
                // projectId: s === true ? '' :  this.projectId,
                // serviceProviderId:  s === true ? '' : this.serviceProviderId,
                // serviceProviderPersonId: s === true ? '' :  this.serviceProviderPersonId,
                // provinceId: s === true ? '' :  this.form.provinceId,
                // cityId: s === true ? '' : this.form.cityid,
                // areaId: s === true ? '' :  this.form.zoneid,
                // streetId:  s === true ? '' : this.form.streetid,
                // communityId: s === true ? '' :  this.form.shequid,
                // approvalStatus:  s === true ? '' : this.tableApprovalStatus,
                pageNo: this.query.pageNo,
                pageSize: this.query.pageSize,
                customerName: this.customerName,
                gender: this.gender,
                projectId: this.projectId,
                serviceProviderId: this.serviceProviderId,
                serviceProviderPersonId: this.serviceProviderPersonId,
                // provinceId:this.form.provinceId,
                ///cityId:this.form.cityid,
                //  areaId:this.form.zoneid,
                //  streetId:this.form.streetid,
                //  communityId:this.form.shequid,
                approvalStatus: this.tableApprovalStatus,
            }
            this.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    // console.log(res)
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                    }
                })
        },
        //获取页面table表格地址
        getElderlyInfoList(s) {
            let params = {
                pageNo: this.query.pageNo,
                pageSize: this.query.pageSize,
                menuType: "elderlyInformation",
            }
            this.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    // console.log(res)
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                        // data.forEach((item) => {
                        //     item.gender = item.gender == "0" ? "男" : "女"
                        // })
                        // this.tableData = data
                    }
                })
        },
        //表单提交
        submitForm() {
            // console.log(1111, this.changeImg)
            if (!this.changeImg) {
                this.submitCheckForm1()
            } else {
                switch (this.stepIndex) {
                    case 0:
                        this.addSubmitForm()
                        break
                    case 2:
                        this.submitDistributionForm()
                        break
                    case 3:
                        this.submitAssessmentForm()
                        break
                    case 4:
                        this.submitCheckForm()
                        break
                    case 5:
                        this.submitEvaluateForm()
                        break
                    case 6:
                        this.submitReturnVisitForm()
                        break
                    case 7:
                        this.submitEndForm()
                        break
                }
            }
        },
        //完工表单提交
        submitEndForm() {
            this.isdisabled = true

            let self = this
            this.$refs["endForm"].validate((valid) => {
                if (valid) {
                    self.$http
                        .request({
                            url: "/jjyl/admin/elderlyInformation/info/insertOrUpdate",
                            method: "POST",
                            data: {
                                approvalStatus: 8,
                                acceptanceApprovalStatus: "",
                                cases: self.endForm.cases,
                                id: self.currentRow.id,
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success("保存成功")
                                this.getElderlyInfoList()
                            } else {
                                this.$message.success("保存失败")
                            }
                            self.dialogVisible = false
                        })
                } else {
                }
            })
        },
        //回访工单提交
        submitReturnVisitForm() {
            let self = this
            self.returnVisitList.forEach((item) => {
                item.evaluateContentId = item.id
                delete item.id
            })
            this.isdisabled = true
            this.$refs["returnVisitForm"].validate((valid) => {
                if (valid) {
                    self.$http
                        .request({
                            url: "/jjyl/admin/elderlyInformation/info/returnVisit",
                            method: "POST",
                            data: {
                                approvalStatus: 7,
                                id: self.currentRow.id,
                                elderlyEvaluateList: self.returnVisitList,
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success("保存成功")
                                this.getElderlyInfoList()
                            } else {
                                this.$message.success("保存失败")
                            }
                            self.dialogVisible = false
                        })
                } else {
                }
            })
        },
        //评价表单提交
        submitEvaluateForm() {
            let self = this
            this.isdisabled = true
            this.$refs["evaluateForm"].validate((valid) => {
                if (valid) {
                    self.$http
                        .request({
                            url: "/jjyl/admin/elderlyInformation/info/insertOrUpdate",
                            method: "POST",
                            data: {
                                ...self.evaluateForm,
                                approvalStatus: 6,
                                publishPlatform: this.publishPlatform,
                                id: self.currentRow.id,
                                acceptanceApprovalStatus: "1",
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success("保存成功")
                                this.getElderlyInfoList()
                            } else {
                                this.$message.success("保存失败")
                            }
                            self.dialogVisible = false
                        })
                } else {
                }
            })
        },
        // 表格新增提交
        addSubmitForm() {
            // console.log(111, this.formData)
            let self = this
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    if (
                        self.formData.elderlyBelongCategory === null ||
                        self.formData.elderlyBelongCategory === "" ||
                        self.formData.elderlyBelongCategory === undefined
                    ) {
                        self.$message.error("老人类型为必填项，请选择")
                        return
                    }
                    if (!self.formData.provinceId) {
                        self.$message.error(
                            "省级地址为必填项，请到资源库完善地址"
                        )
                        return
                    }
                    if (!self.formData.cityId) {
                        self.$message.error(
                            "市级地址为必填项，请到资源库完善地址"
                        )
                        return
                    }
                    if (!self.formData.areaId) {
                        self.$message.error(
                            "区县级地址为必填项，请到资源库完善地址"
                        )
                        return
                    }
                    if (!self.formData.streetId) {
                        self.$message.error(
                            "街道地址为必填项，请到资源库完善地址"
                        )
                        return
                    }
                    if (
                        self.formData.communityId === "" ||
                        self.formData.communityId === null ||
                        self.formData.communityId === undefined
                    ) {
                        self.$message.error(
                            "社区为必填项，请选择,如无对应社区，请地址管理配置"
                        )
                        return
                    }
                    if (!self.formData.address) {
                        self.$message.error(
                            "详细信息为必填项，请在地图的边界内点击选择详细信息"
                        )
                        return
                    }
                    if (self.dialogVisibleTitle == "新增") {
                        self.formData.id = ""
                    } else if (self.dialogVisibleTitle == "编辑") {
                        self.formData.oldId = c
                    }

                    if (self.formData.id) {
                        self.formData.idCard = ""
                        self.formData.phone = ""
                    }
                    this.isdisabled = true
                    self.$http
                        .request({
                            url: "/jjyl/admin/elderlyInformation/info/insertOrUpdate",
                            method: "POST",
                            data: {
                                approvalStatus: 0,
                                ...self.formData,
                            },
                        })
                        .then((res) => {
                            if (res.code === 200) {
                                self.$message.success("新增老人信息成功")
                                self.getElderlyInfoList()
                            } else {
                                self.$message.error("新增老人信息失败")
                            }
                            self.dialogVisible = false
                        })
                } else {
                }
            })
        },
        //分配表单提交
        submitDistributionForm() {
            let self = this
            self.$refs["distributionForm"].validate((valid) => {
                if (valid) {
                    let temp = JSON.stringify(self.distributionForm)
                    let tempArr = JSON.parse(temp)
                    if (
                        tempArr &&
                        tempArr.serviceProviderPersonId &&
                        tempArr.serviceProviderPersonId.length > 0
                    ) {
                        tempArr.serviceProviderPersonId =
                            tempArr.serviceProviderPersonId.join(",")
                    } else {
                        tempArr.serviceProviderPersonId = ""
                    }
                    this.isdisabled = true
                    self.$http
                        .request({
                            url: "/jjyl/admin/elderlyInformation/info/insertOrUpdate",
                            method: "POST",
                            isUpload: "false",
                            data: {
                                projectId: tempArr.projectId,
                                serviceProviderId: tempArr.serviceProviderId,
                                serviceProviderPersonId:
                                    tempArr.serviceProviderPersonId,
                                approvalStatus: 1,
                                id: this.currentRow.id,
                                ids: this.selectedData,
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                self.$message.success("保存分配信息成功")
                                self.getElderlyInfoList()
                            } else {
                                self.$message.error("保存分配信息失败")
                            }
                            self.dialogVisible = false
                        })
                } else {
                }
            })
            this.$refs.multipleTable.clearSelection()
        },
        //评估表单提交
        submitAssessmentForm() {
            let self = this
            let temp = ""
            if (this.assessmentForm.assessApprovalStatus == 1) {
                temp = 2
            } else {
                temp = 3
            }
            let tempOne = JSON.stringify(this.assessmentForm)
            let tempTwo = JSON.parse(tempOne)
            tempTwo.medicalHistory.forEach((item, index) => {
                self.medicalHistoryList.forEach((child) => {
                    //病史
                    if (item == child.laebl) {
                        tempTwo.medicalHistory[index] = child.id
                    }
                })
            })
            tempTwo.medicalHistory = tempTwo.medicalHistory.join(",")
            tempTwo.approvalStatus = temp
            // tempTwo.elderlyBelongCategory.forEach((item, index) => {//老人类别
            //   self.elderlyTypeList.forEach((child) => {
            //     if (item == child.label) {
            //       tempTwo.elderlyBelongCategory[index] = child.id;
            //     }
            //   });
            // });
            // tempTwo.elderlyBelongCategory = tempTwo.elderlyBelongCategory.join(",");
            if (this.assessmentForm.assessApprovalStatus != 1) {
                if (!this.assessmentForm.assessApprovalReasons) {
                    this.$message.error("审核未通过请填写原因")
                    return
                }
            }
            // approvalStatus: temp,
            this.isdisabled = true
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/insertOrUpdate",
                    method: "POST",
                    data: {
                        ...tempTwo,
                        id: self.currentRow.id,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        self.$message.success("审核信息成功")
                        self.getElderlyInfoList()
                    } else {
                        self.$message.error("审核信息失败")
                    }
                    self.dialogVisible = false
                })
        },
        //施工督查表单提交
        submitCheckForm() {
            let self = this
            let temp = ""
            if (self.checkForm.constructionApprovalStatus == 0) {
                if (!self.checkForm.constructionApprovalReasons) {
                    self.$message.error("审核未通过请填写原因")
                    return
                }
            }
            if (self.checkForm.constructionApprovalStatus == 0) {
                temp = 5
            } else {
                temp = 4
            }
            this.isdisabled = true
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/insertOrUpdate",
                    method: "POST",
                    data: {
                        approvalStatus: temp,
                        ...self.checkForm,
                        id: self.currentRow.id,
                        balconyPhoto: this.imgforms.balconyPhotoShows.join("#"),
                        balconyAfterPhoto:
                            this.imgforms.balconyAfterPhotoShows.join("#"),
                        bedroomPhoto: this.imgforms.bedroomPhotoShows.join("#"),
                        bedroomAfterPhoto:
                            this.imgforms.bedroomAfterPhotoShows.join("#"),
                        kitchenPhoto: this.imgforms.kitchenPhotoShows.join("#"),
                        kitchenAfterPhoto:
                            this.imgforms.kitchenAfterPhotoShows.join("#"),
                        livingRoomPhoto:
                            this.imgforms.livingRoomPhotoShows.join("#"),
                        livingRoomAfterPhoto:
                            this.imgforms.livingRoomAfterPhotoShows.join("#"),
                        toiletPhoto: this.imgforms.toiletPhotoShows.join("#"),
                        toiletAfterPhoto:
                            this.imgforms.toiletAfterPhotoShows.join("#"),
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        self.$message.success("保存成功")
                        self.getElderlyInfoList()
                    } else {
                        self.$message.error("保存失败")
                    }
                    self.dialogVisible = false
                })
        },
        showImg(val) {
            if (!this.changeImg) {
                if (val == "阳台前") {
                    this.imgList = this.imgforms.balconyPhotoShows
                }
                if (val == "阳台后") {
                    this.imgList = this.imgforms.bedroomAfterPhotoShows
                }
                if (val == "卧室前") {
                    this.imgList = this.imgforms.bedroomPhotoShows
                }
                if (val == "卧室后") {
                    this.imgList = this.imgforms.bedroomAfterPhotoShows
                }
                if (val == "厨房前") {
                    this.imgList = this.imgforms.kitchenPhotoShows
                }
                if (val == "厨房后") {
                    this.imgList = this.imgforms.kitchenAfterPhotoShows
                }
                if (val == "客厅前") {
                    this.imgList = this.imgforms.livingRoomPhotoShows
                }
                if (val == "客厅后") {
                    this.imgList = this.imgforms.livingRoomAfterPhotoShows
                }
                if (val == "卫生间前") {
                    this.imgList = this.imgforms.toiletPhotoShows
                }
                if (val == "卫生间后") {
                    this.imgList = this.imgforms.toiletAfterPhotoShows
                }
                this.showImgList = true
                // console.log(this.imgList, this.showImgList)
                this.listTitle = val
            }
        },
        closeImgList() {
            if (this.listTitle == "阳台前") {
                this.imgforms.balconyPhotoShows = this.imgList
            }
            if (this.listTitle == "阳台后") {
                this.imgforms.bedroomAfterPhotoShows = this.imgList
            }
            if (this.listTitle == "卧室前") {
                this.imgforms.bedroomPhotoShows = this.imgList
            }
            if (this.listTitle == "卧室后") {
                this.imgforms.bedroomAfterPhotoShows = this.imgList
            }
            if (this.listTitle == "厨房前") {
                this.imgforms.kitchenPhotoShows = this.imgList
            }
            if (this.listTitle == "厨房后") {
                this.imgforms.kitchenAfterPhotoShows = this.imgList
            }
            if (this.listTitle == "客厅前") {
                this.imgforms.livingRoomPhotoShows = this.imgList
            }
            if (this.listTitle == "客厅后") {
                this.imgforms.livingRoomAfterPhotoShows = this.imgList
            }
            if (this.listTitle == "卫生间前") {
                this.imgforms.toiletPhotoShows = this.imgList
            }
            if (this.listTitle == "卫生间后") {
                this.imgforms.toiletAfterPhotoShows = this.imgList
            }
            this.showImgList = false
            this.listTitle = ""
            this.imgIndex = 0
        },
        jian(index) {
            if (index > 0) {
                this.imgIndex = index - 1
            }
        },
        jia(index) {
            if (index < this.imgList.length - 1) {
                this.imgIndex = index + 1
            }
        },
        delImg(index) {
            this.imgList.splice(index, 1)
            this.imgIndex = index - 1
        },
        // 编辑施工督查表单提交
        submitCheckForm1() {
            // console.log(111)
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/insertOrUpdate",
                    method: "POST",
                    data: {
                        approvalStatus: 8,
                        acceptanceApprovalStatus: "",
                        id: self.currentRow.id,
                        balconyPhoto: this.imgforms.balconyPhotoShows.join("#"),
                        balconyAfterPhoto:
                            this.imgforms.balconyAfterPhotoShows.join("#"),
                        bedroomPhoto: this.imgforms.bedroomPhotoShows.join("#"),
                        bedroomAfterPhoto:
                            this.imgforms.bedroomAfterPhotoShows.join("#"),
                        kitchenPhoto: this.imgforms.kitchenPhotoShows.join("#"),
                        kitchenAfterPhoto:
                            this.imgforms.kitchenAfterPhotoShows.join("#"),
                        livingRoomPhoto:
                            this.imgforms.livingRoomPhotoShows.join("#"),
                        livingRoomAfterPhoto:
                            this.imgforms.livingRoomAfterPhotoShows.join("#"),
                        toiletPhoto: this.imgforms.toiletPhotoShows.join("#"),
                        toiletAfterPhoto:
                            this.imgforms.toiletAfterPhotoShows.join("#"),
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        self.$message.success("保存成功")
                        self.getElderlyInfoList()
                    } else {
                        self.$message.error("保存失败")
                    }
                    self.dialogVisible = false
                })
        },
        //获取老人信息
        getById(row) {
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/getById",
                    method: "POST",
                    data: {
                        id: row.id,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        let data = res.content
                        if (self.stepIndex == 3) {
                            this.assessmentForm.hearingStatus =
                                data.hearingStatus //听力状况
                            if (data.medicalHistory != null) {
                                //病史
                                data.medicalHistory &&
                                    data.medicalHistory
                                        .split(",")
                                        .forEach((item) => {
                                            this.medicalHistoryList.forEach(
                                                (child) => {
                                                    if (item === child.id) {
                                                        this.assessmentForm.medicalHistory.push(
                                                            child.laebl
                                                        )
                                                    }
                                                }
                                            )
                                        })
                            }
                            this.assessmentForm.customerName = data.customerName //
                            this.assessmentForm.assessConfirmation =
                                data.assessConfirmation //评估单
                            this.assessmentForm.assessResult = data.assessResult
                            this.assessmentForm.intelligence = data.intelligence
                            this.assessmentForm.shower = data.shower
                            this.assessmentForm.walking = data.walking
                            this.assessmentForm.toilet = data.toilet
                            this.assessmentForm.dressing = data.dressing
                            this.assessmentForm.eat = data.eat
                            this.assessmentForm.bed = data.bed
                            this.assessmentForm.selfCareCategory =
                                data.selfCareCategory
                            this.assessmentForm.familyMembersAssess =
                                data.familyMembersAssess //家庭成员评估
                            this.assessmentForm.elevator = data.elevator //电梯
                            this.assessmentForm.indoorToilet = data.indoorToilet //室内厕所
                            this.assessmentForm.indoorBathEquipment =
                                data.indoorBathEquipment //室内助浴设备
                            this.assessmentForm.buildingStructure =
                                data.buildingStructure //房屋建筑结构
                            this.assessmentForm.residentialFloor =
                                data.residentialFloor //居住楼层
                            this.assessmentForm.balconyPhoto = data.balconyPhoto //阳台
                            this.assessmentForm.bedroomPhoto = data.bedroomPhoto //卧室
                            this.assessmentForm.kitchenPhoto = data.kitchenPhoto //厨房
                            this.assessmentForm.livingRoomPhoto =
                                data.livingRoomPhoto //客厅
                            this.assessmentForm.toiletPhoto = data.toiletPhoto //卫生间
                            this.assessmentForm.approvalStatus =
                                data.approvalStatus //是否放弃评估
                            this.assessmentForm.elderlySubProManageList =
                                data.elderlySubProManageList //清单列表
                            this.assessmentForm.currentApprovalStatus =
                                data.approvalStatus //当前状态
                            this.assessmentForm.assessApprovalReasons =
                                data.assessApprovalReasons

                            this.imgforms.elderlyPhotoList =
                                data.elderlyPhotoList //新增项目列表
                            if (data.balconyPhoto != null) {
                                this.imgforms.balconyPhotoShows =
                                    data.balconyPhoto.split("#")
                            }
                            if (data.bedroomPhoto != null) {
                                this.imgforms.bedroomPhotoShows =
                                    data.bedroomPhoto.split("#")
                            }
                            if (data.kitchenPhoto != null) {
                                this.imgforms.kitchenPhotoShows =
                                    data.kitchenPhoto.split("#")
                            }
                            if (data.livingRoomPhoto != null) {
                                this.imgforms.livingRoomPhotoShows =
                                    data.livingRoomPhoto.split("#")
                            }
                            if (data.toiletPhoto != null) {
                                this.imgforms.toiletPhotoShows =
                                    data.toiletPhoto.split("#")
                            }

                            //阳台
                            if (
                                data.assessApprovalStatus !== null &&
                                data.assessApprovalStatus !== ""
                            ) {
                                this.$set(
                                    this.assessmentForm,
                                    "assessApprovalStatus",
                                    Number(data.assessApprovalStatus)
                                )
                            }
                            if (data.assessConfirmation != null) {
                                this.imgforms.assessConfirmationShows =
                                    data.assessConfirmation.split("#")
                            }
                            if (data.approvalStatus == 10) {
                                this.assessmentForm.assessAbandonEnclosure =
                                    data.assessAbandonEnclosure //放弃附件
                                this.assessmentForm.assessAbandonReasons =
                                    data.assessAbandonReasons //放弃原因
                            }
                        }
                        if (self.stepIndex == 4) {
                            // self.checkForm.assessConfirmation = data.assessConfirmation //评估单
                            self.checkForm.balconyPhoto = data.balconyPhoto //阳台
                            self.checkForm.bedroomPhoto = data.bedroomPhoto //卧室
                            self.checkForm.kitchenPhoto = data.kitchenPhoto //厨房
                            self.checkForm.livingRoomPhoto =
                                data.livingRoomPhoto //客厅
                            self.checkForm.toiletPhoto = data.toiletPhoto //卫生间
                            self.checkForm.balconyAfterPhoto =
                                data.balconyAfterPhoto //阳台改造后
                            self.checkForm.bedroomAfterPhoto =
                                data.bedroomAfterPhoto //卧室改造后
                            self.checkForm.kitchenAfterPhoto =
                                data.kitchenAfterPhoto //厨房改造后
                            self.checkForm.livingRoomAfterPhoto =
                                data.livingRoomAfterPhoto //客厅改造后
                            self.checkForm.toiletAfterPhoto =
                                data.toiletAfterPhoto //卫生间改造后
                            if (data.balconyPhoto != null) {
                                this.imgforms.balconyPhotoShows =
                                    data.balconyPhoto.split("#")
                            }
                            if (data.bedroomPhoto != null) {
                                this.imgforms.bedroomPhotoShows =
                                    data.bedroomPhoto.split("#")
                            }
                            if (data.kitchenPhoto != null) {
                                this.imgforms.kitchenPhotoShows =
                                    data.kitchenPhoto.split("#")
                            }
                            if (data.livingRoomPhoto != null) {
                                this.imgforms.livingRoomPhotoShows =
                                    data.livingRoomPhoto.split("#")
                            }
                            if (data.toiletPhoto != null) {
                                this.imgforms.toiletPhotoShows =
                                    data.toiletPhoto.split("#")
                            }
                            if (data.balconyAfterPhoto != null) {
                                this.imgforms.balconyAfterPhotoShows =
                                    data.balconyAfterPhoto.split("#")
                            }
                            if (data.bedroomAfterPhoto != null) {
                                this.imgforms.bedroomAfterPhotoShows =
                                    data.bedroomAfterPhoto.split("#")
                            }
                            if (data.kitchenAfterPhoto != null) {
                                this.imgforms.kitchenAfterPhotoShows =
                                    data.kitchenAfterPhoto.split("#")
                            }
                            if (data.livingRoomAfterPhoto != null) {
                                this.imgforms.livingRoomAfterPhotoShows =
                                    data.livingRoomAfterPhoto.split("#")
                            }
                            if (data.toiletAfterPhoto != null) {
                                this.imgforms.toiletAfterPhotoShows =
                                    data.toiletAfterPhoto.split("#")
                            }

                            this.imgforms.elderlyPhotoList =
                                data.elderlyPhotoList //新增项目列表
                            self.checkForm.elderlySubProManageList =
                                data.elderlySubProManageList //评估单
                            self.checkForm.currentApprovalStatus =
                                data.approvalStatus
                            this.checkForm.constructionApprovalReasons =
                                data.constructionApprovalReasons
                            if (
                                data.constructionApprovalStatus !== null &&
                                data.constructionApprovalStatus !== ""
                            ) {
                                this.$set(
                                    this.checkForm,
                                    "constructionApprovalStatus",
                                    Number(data.constructionApprovalStatus)
                                )
                            }
                            if (data.approvalStatus == 12) {
                                self.checkForm.constructionAbandonReasons =
                                    data.constructionAbandonReasons //放弃原因
                                self.checkForm.constructionAbandonEnclosure =
                                    data.constructionAbandonEnclosure //放弃证明
                            }
                        }
                    }
                })
        },
        //老人信息列表pagesize发生改变
        handleCurrentChange(val) {
            this.query.pageNo = val
            this.getElderlyInfoList()
        },
        //老人信息列表页码发生改变
        handleSizeChange(val) {
            this.query.pageSize = val
            this.getElderlyInfoList()
        },
        //评价内容新增弹窗关闭回调
        setUpDialogClose() {
            this.setUpDialogForm.typeName = "" //类型名称
            this.setUpDialogForm.publishPlatform = "0" //类型名称
            this.setUpDialogForm.evaluateContentList = []
            this.AddDialogRow = [] //评价内容当前行内容
            this.addProblemList = [] //问题集合清空
        },
        // 评价内容设置新增删除修改
        handleAddDialogData(type, row) {
            let self = this
            if (type == "删除") {
                self.$confirm("是否删除该条记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        self.deleteEvaluateType(row.id)
                    })
                    .catch(() => {
                        self.$message({
                            type: "info",
                            message: "已取消删除",
                        })
                    })
            } else {
                self.setUpDialog = true
                self.AddDialogType = type
                self.AddDialogRow = row
                if (type == "编辑") {
                    this.$http
                        .request({
                            url: "/jjyl/admin/evaluateType/info/getById",
                            method: "POST",
                            data: {
                                id: row.id,
                            },
                        })
                        .then((res) => {
                            // console.log(res)
                            if (res.code == 200) {
                                if (
                                    res.content == null ||
                                    res.content == "null"
                                )
                                    return
                                res.content.evaluateContentList.forEach(
                                    (item) => {
                                        item.replySelection = Number(
                                            item.replySelection
                                        )
                                    }
                                )
                                this.addProblemList =
                                    res.content.evaluateContentList
                            }
                        })
                    this.setUpDialogForm.typeName = row.typeName
                    // console.log(this.ssorgList, row.dataId)
                    this.setUpDialogForm.dataName = this.setDataName(
                        this.ssorgList,
                        row.dataId
                    )
                    this.setUpDialogForm.publishPlatform = row.publishPlatform
                } else {
                    this.setUpDialogForm.dataId = ""
                    this.setUpDialogForm.dataName = ""
                    this.ssorgList = []
                    this.getssOrg()
                }
            }
        },

        //编辑确认按钮
        editRoomlist() {
            this.setUpDialogDeit = false
            let params = this.formDataEdit
            this.formDataEdit.oldId = this.formDataEdit.cusId
            this.formDataEdit.cc = this.formDataEdit.name
            this.formDataEdit.photo = this.imageUrl
            this.formDataEdit.phone = ""
            this.formDataEdit.idCard = ""
            // return;
            this.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/insertOrUpdate",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.getElderlyInfoList()
                    }
                })
        },
        editCancel() {
            this.setUpDialogDeit = false
        },
        // 添加问题
        handelAddProblem() {
            this.addProblemList.unshift({
                questionName: "",
                replySelection: 0,
                reason: "",
            })
        },
        //删除评价列表
        deleteEvaluateType(id) {
            this.$http
                .request({
                    url: "/jjyl/admin/evaluateType/info/deleteById",
                    method: "POST",
                    data: {
                        id: id,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        this.$message.success("删除成功")
                        this.getEvaluateType()
                    }
                })
        },
        //获取评价列表
        getEvaluateType() {
            this.$http
                .request({
                    url: "/jjyl/admin/evaluateType/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        qujiId: JSON.parse(localStorage.getItem("czUserInfo"))
                            .qujiId,
                        shengjiId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).shengjiId,
                        shijiId: JSON.parse(localStorage.getItem("czUserInfo"))
                            .shijiId,
                        stationId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).stationId,
                        shequjiId: JSON.parse(
                            localStorage.getItem("czUserInfo")
                        ).shequjiId,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.addDialog = true
                        this.addDialogData = res.content.list
                        if (res.content == null || res.content == "null") {
                            this.addDialogData = []
                        }
                    }
                })
        },
        // 新增评价类型
        addEvaluateType() {
            let data = {}
            if (!this.setUpDialogForm.typeName) {
                this.$message.error("类型名称不能为空")
                return
            }
            if (this.addProblemList.length == 0) {
                this.$message.error("至少新增一条问题")
                return
            }
            for (let i = 0; i < this.addProblemList.length; i++) {
                const element = this.addProblemList[i]
                if (!element.questionName) {
                    this.$message.error("问题内容不得为空")
                    return
                }
            }
            if (this.AddDialogType == "编辑") {
                Object.assign(data, {
                    id: this.AddDialogRow.id,
                    evaluateContentList: this.addProblemList,
                    typeName: this.setUpDialogForm.typeName,
                    publishPlatform: this.setUpDialogForm.publishPlatform,
                    dataId: this.setUpDialogForm.dataId,
                })
            }
            if (this.AddDialogType == "编辑") {
                this.$http
                    .request({
                        url: "/jjyl/admin/evaluateType/info/update",
                        method: "POST",
                        data,
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            this.$message.success("编辑类型成功")
                            this.getEvaluateType()
                        } else {
                            this.$message.success("编辑类型失败")
                        }
                        this.setUpDialog = false
                    })
            }
            if (this.AddDialogType == "新增") {
                // console.log(this.setUpDialogForm)
                this.$http
                    .request({
                        url: "/jjyl/admin/evaluateType/info/update",
                        method: "POST",
                        data: {
                            ...this.setUpDialogForm,
                            evaluateContentList: this.addProblemList,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            this.$message.success("新增类型成功")
                            this.getEvaluateType()
                        } else {
                            this.$message.success("新增类型失败")
                        }
                        this.setUpDialog = false
                    })
            }
        },
        // 评价内容设置弹窗关闭回调
        addDialogClose() {},
        // 获取老人全程问题
        getElderlyInformation(id) {
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/elderlyInformation/info/finished",
                    method: "POST",
                    data: {
                        id,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null && res.content == "null") return
                        self.elderlyInformationList = res.content
                    }
                })
        },
        //清空搜索条件
        handleEmpty() {
            this.pageSize = 10
            this.pageNo = 1
            this.username = ""
            this.gender = ""
            this.tableApprovalStatus = ""
            this.projectId = ""
            this.serviceProviderId = ""
            this.serviceProviderPersonId = ""
            this.form.provinceId = ""
            this.form.cityid = "" //居住地址
            this.form.zoneid = "" //居住地址
            this.form.streetid = "" //居住地址
            this.form.shequid = ""
            this.getElderlyInfoList()
        },
        handleSelectionChange(data) {
            this.selectedData = data
        },
        //获取回访数据
        getReturnVisit() {
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/evaluateType/info/getById",
                    method: "POST",
                    data: {
                        id: self.currentRow.assessType,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") return
                        let temp = res.content.evaluateContentList
                        this.returnVisitList = temp
                    }
                })
        },
        //获取人员信息
        getPersonMsg(id) {
            this.choosePersonnelList = []
            this.$http
                .request({
                    url: "/jjyl/admin/personMsg/info/findList",
                    method: "POST",
                    data: {
                        deptId: id,
                        status: 0,
                        pageNo: 1,
                        pageSize: 1000,
                        dataId: this.datasid,
                    },
                })
                .then((res) => {
                    if (res.content == null || res.content == "null") {
                        this.choosePersonnelList = []
                        return
                    }
                    this.choosePersonnelList = res.content.list
                })
        },
        //部门选项框发生变化
        chooseDepartmentChange(val) {
            this.evaluateForm.selectPersonId = ""
            this.getPersonMsg(val)
        },
        //评价方式值发生变化
        evaluateTypeChange(val) {
            if (val) {
                for (let i = 0; i < this.evaluateTypetList.length; i++) {
                    if (this.evaluateTypetList[i].id == val) {
                        if (this.evaluateTypetList[i].publishPlatform == "0") {
                            this.approvalStatuss = 6
                            this.evaluateForm.publishPlatform =
                                this.evaluateTypetList[i].publishPlatform
                        } else {
                            this.approvalStatuss = 6
                            this.evaluateForm.publishPlatform =
                                this.evaluateTypetList[i].publishPlatform
                        }
                    }
                }
            }
            let self = this
            self.$http
                .request({
                    url: "/jjyl/admin/evaluateType/info/getById",
                    method: "POST",
                    data: {
                        id: val,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") return
                        let temp = res.content.evaluateContentList
                        self.evaluateTypeList = temp
                    }
                })
        },
        // 获取部门信息
        getDeptManage() {
            this.$http
                .request({
                    url: "/jjyl/admin/deptManage/info/findList",
                    method: "POST",
                    data: {
                        status: 0,
                        pageNo: 1,
                        pageSize: 1000,
                        dataId: this.datasid,
                    },
                })
                .then((res) => {
                    if (res.content == null || res.content == "null") return
                    this.chooseDepartmentList = res.content.list
                })
        },
        //获取类型列表
        getEvaluateTypeInfo() {
            this.$http
                .request({
                    url: "/jjyl/admin/evaluateType/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        dataId: this.datasid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content == null || res.content == "null") return
                        this.evaluateTypetList = res.content.list
                    }
                })
        },
        //加载地图
        loadmap(container) {
            return new Promise((resolve, reject) => {
                this.myMap = new AMap.Map(container, {
                    resizeEnable: true,
                    zoom: 18,
                })
                this.myMap.on("complete", () => {
                    resolve()
                })
            })
        },
        //table表格表单弹窗关闭时事件
        dialogVisibleClone() {
            let self = this
            self.currentRow = {}
            this.isStepsfzc = 2
            this.$refs.formData.resetFields()
            // 新增/修改
            self.imageUrl = ""
            self.formData.photo = ""
            self.formData.name = "" //姓名
            self.formData.gender = "" //性别
            self.formData.phone = "" //联系方式
            self.formData.idCard = "" //身份证号
            self.formData.age = "" //年龄
            self.formData.elderlyBelongCategory = "" //老人类型
            self.formData.provinceId = "" //省
            self.formData.cityId = "" //市
            self.formData.areaId = "" //区
            self.formData.street = "" //街道
            self.formData.community = "" //社区
            self.formData.address = "" //居住地址
            self.formData.streetId = ""
            self.formData.longitude = ""
            self.formData.latitude = ""
            self.formData.communityId = ""
            self.formData.orgName = ""
            self.cityList = []
            self.areaList = []
            self.streetList = []
            self.communityList = []

            //分配表单
            self.distributionForm.projectId = "" //分配项目
            self.distributionForm.serviceProviderId = "" //分配服务商
            self.distributionForm.leader = "" //负责人
            self.distributionForm.serviceProviderPersonId = [] //施工员
            self.providerPersonList = [] //施工员

            //评估审核
            self.elderlyBelongCategory = "" //老人类别
            self.hearingStatus = "" //听力状况
            self.assessmentForm.medicalHistory = [] //病史
            self.assessmentForm.assessConfirmation = "" //评估单
            self.assessmentForm.familyMembersAssess = "" //家庭成员评估
            self.assessmentForm.elevator = "" //电梯
            self.assessmentForm.indoorToilet = "" //室内厕所
            self.assessmentForm.indoorBathEquipment = "" //室内助浴设备
            self.assessmentForm.buildingStructure = "" //房屋建筑结构
            self.assessmentForm.residentialFloor = "" //居住楼层
            self.assessmentForm.balconyPhoto = "" //阳台
            self.assessmentForm.bedroomPhoto = "" //卧室
            self.assessmentForm.kitchenPhoto = "" //厨房
            self.assessmentForm.livingRoomPhoto = "" //客厅
            self.assessmentForm.toiletPhoto = "" //卫生间
            self.assessmentForm.assessApprovalStatus = 1 //审核状态
            self.assessmentForm.assessApprovalReasons = "" //原因
            self.assessmentForm.assessAbandonReasons = "" //放弃原因
            self.assessmentForm.assessAbandonEnclosure = "" //放弃证明
            self.assessmentForm.currentApprovalStatus = "" //当前状态
            self.assessmentForm.assessResult = ""
            self.assessmentForm.intelligence = ""
            self.assessmentForm.shower = ""
            self.assessmentForm.walking = ""
            self.assessmentForm.toilet = ""
            self.assessmentForm.dressing = ""
            self.assessmentForm.eat = ""
            self.assessmentForm.bed = ""
            self.imgforms.balconyPhotoShows = []
            self.imgforms.bedroomPhotoShows = []
            self.imgforms.kitchenPhotoShows = []
            self.imgforms.livingRoomPhotoShows = []
            self.imgforms.toiletPhotoShows = []
            //施工审核
            self.imgforms.balconyAfterPhotoShows = []
            self.imgforms.bedroomAfterPhotoShows = []
            self.imgforms.kitchenAfterPhotoShows = []
            self.imgforms.livingRoomAfterPhotoShows = []
            self.imgforms.toiletAfterPhotoShows = []
            self.imgforms.assessConfirmationShows = []
            self.checkForm.assessConfirmation = "" //评估单
            self.checkForm.straightArmrestBefore = "" //扶手改造前
            self.checkForm.straightArmrestAfter = "" //扶手改造后
            self.checkForm.smokeDetectorBefore = "" //烟雾报警器改造前
            self.checkForm.smokeDetectorAfter = "" //烟雾报警器改造后
            self.checkForm.constructionAbandonReasons = "" //放弃原因
            self.checkForm.constructionAbandonEnclosure = "" //放弃证明
            self.checkForm.constructionApprovalStatus = 1 //审核状态
            self.checkForm.constructionApprovalReasons = "" //原因
            self.checkForm.currentApprovalStatus = ""
            self.checkForm.assessConfirmation = "" //评估单
            self.checkForm.balconyPhoto = "" //阳台
            self.checkForm.bedroomPhoto = "" //卧室
            self.checkForm.kitchenPhoto = "" //厨房
            self.checkForm.livingRoomPhoto = "" //客厅
            self.checkForm.toiletPhoto = "" //卫生间
            self.checkForm.balconyAfterPhoto = "" //阳台改造后
            self.checkForm.bedroomAfterPhoto = "" //卧室改造后
            self.checkForm.kitchenAfterPhoto = "" //厨房改造后
            self.checkForm.livingRoomAfterPhoto = "" //客厅改造后
            self.checkForm.toiletAfterPhoto = "" //卫生间改造后
            self.proveImageUrl = ""

            //评价
            self.evaluateForm.assessType = "" //评价方式
            self.evaluateForm.selectDeptId = "" //选择部门
            self.evaluateForm.selectPersonId = "" //选择人员
            self.evaluateTypeList = []

            //回访工单
            self.returnVisitForm.file = ""
            self.returnVisitList = []

            //完工
            self.elderlyInformationList = []
            self.endForm.cases = "0"
            // switch (this.stepIndex) {
            //   // case 0:
            //   // case 1:
            //   //   self.imageUrl = "";
            //   //   self.formData.photo = "";
            //   //   self.formData.name = ""; //姓名
            //   //   self.formData.gender = "0"; //性别
            //   //   self.formData.phone = ""; //联系方式
            //   //   self.formData.idCard = ""; //身份证号
            //   //   self.formData.age = ""; //年龄
            //   //   self.formData.elderlyBelongCategory = ""; //老人类型
            //   //   self.formData.provinceId = ""; //省
            //   //   self.formData.cityId = ""; //市
            //   //   self.formData.areaId = ""; //区
            //   //   self.formData.street = ""; //街道
            //   //   self.formData.community = ""; //社区
            //   //   self.formData.address = ""; //居住地址
            //   //   self.formData.streetId = "";
            //   //   self.formData.longitude = "";
            //   //   self.formData.latitude = "";
            //   //   self.formData.communityId = "";
            //   //   self.cityList = [];
            //   //   self.areaList = [];
            //   //   self.streetList = [];
            //   //   self.communityList = []
            //   //   break;
            //   // case 2: //分配表单
            //   //   self.distributionForm.projectId = ""; //分配项目
            //   //   self.distributionForm.serviceProviderId = ""; //分配服务商
            //   //   self.distributionForm.leader = ""; //负责人
            //   //   self.distributionForm.serviceProviderPersonId = []; //施工员
            //   //   self.providerPersonList = []; //施工员
            //   //   break;
            //   // case 3:
            //   //   self.elderlyBelongCategory = ''; //老人类别
            //   //   self.hearingStatus = ""; //听力状况
            //   //   self.assessmentForm.medicalHistory = []; //病史
            //   //   self.assessmentForm.familyMembersAssess = ""; //家庭成员评估
            //   //   self.assessmentForm.elevator = ""; //电梯
            //   //   self.assessmentForm.indoorToilet = ""; //室内厕所
            //   //   self.assessmentForm.indoorBathEquipment = ""; //室内助浴设备
            //   //   self.assessmentForm.buildingStructure = ""; //房屋建筑结构
            //   //   self.assessmentForm.residentialFloor = ""; //居住楼层
            //   //   self.assessmentForm.balconyPhoto = ""; //阳台
            //   //   self.assessmentForm.bedroomPhoto = ""; //卧室
            //   //   self.assessmentForm.kitchenPhoto = ""; //厨房
            //   //   self.assessmentForm.livingRoomPhoto = ""; //客厅
            //   //   self.assessmentForm.toiletPhoto = ""; //卫生间
            //   //   self.assessmentForm.assessApprovalStatus = 1; //审核状态
            //   //   self.assessmentForm.assessApprovalReasons = ""; //原因
            //   //   self.assessmentForm.assessAbandonReasons = ""; //放弃原因
            //   //   self.assessmentForm.assessAbandonEnclosure = ""; //放弃证明
            //   //   self.assessmentForm.currentApprovalStatus = ""; //当前状态
            //   // case 4:
            //   //   self.checkForm.assessConfirmation = ""; //评估单
            //   //   self.checkForm.straightArmrestBefore = ""; //扶手改造前
            //   //   self.checkForm.straightArmrestAfter = ""; //扶手改造后
            //   //   self.checkForm.smokeDetectorBefore = ""; //烟雾报警器改造前
            //   //   self.checkForm.smokeDetectorAfter = ""; //烟雾报警器改造后
            //   //   self.checkForm.constructionAbandonReasons = ""; //放弃原因
            //   //   self.checkForm.constructionAbandonEnclosure = ""; //放弃证明
            //   //   self.checkForm.constructionApprovalStatus = 1; //审核状态
            //   //   self.checkForm.constructionApprovalReasons = ""; //原因
            //   //   self.checkForm.currentApprovalStatus = ''
            //   //   self.proveImageUrl = ''
            //   //   break;
            //   // case 5:
            //   //   self.evaluateForm.assessType = ""; //评价方式
            //   //   self.evaluateForm.selectDeptId = ""; //选择部门
            //   //   self.evaluateForm.selectPersonId = ""; //选择人员
            //   //   self.evaluateTypeList = []
            //   //   break;
            //   // case 6:
            //   //   self.returnVisitForm.file = ''
            //   //   self.returnVisitList = []
            //   //   break;
            //   case 7:
            //     self.elderlyInformationList = []
            //     self.endForm.cases = "0"
            //     break;
            // }
        },
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return isJPG
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
                return isLt2M
            }
        },
        //自定义图片上传
        handleAvatarSuccess(res, file, name) {
            if (name == "add") {
                //新增图片
                this.imageUrl = res.content
                this.formData.photo = res.content
            }
            if (name == "prove") {
                this.imageUrlSix = res.content
                this.assessmentForm.assessAbandonEnclosure = res.content //放弃证明
            }
            if (name == "proveImageUrl") {
                //施工督查放弃证明
                this.proveImageUrl = res.content
                this.checkForm.constructionAbandonEnclosure = res.content
            }
            if (name == "returnVisitImages") {
                //回访工单放弃证明
                this.returnVisitImages = res.content
                this.returnVisitForm.file = res.content
            }
        },
        //获取项目列表
        getProjectManage() {
            this.$http
                .request({
                    url: "/jjyl/admin/projectManage/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        dataId: this.datasid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content == null || res.content == "null") {
                            this.projectManageList = []
                            return
                        }
                        this.projectManageList = res.content.list
                    }
                })
        },
        //获取服务商列表
        getServiceProvider(dataId) {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceProvider/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        dataId: dataId,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content == null || res.content == "null") {
                            this.providerList = []
                            return
                        }
                        this.providerList = res.content.list
                    }
                })
        },
        //服务商选择框发生变化
        providerChange(val, index) {
            this.providerList.forEach((item) => {
                item.id == val && (this.distributionForm.leader = item.leader)
            })
            this.getServiceProviderPerson(val)
        },
        //服务商选择框发生变化
        providerChange1(val, index) {
            this.providerList.forEach((item) => {
                item.id == val && (this.distributionForm.leader = item.leader)
            })
            this.serviceProviderPersonId = ""
            this.getServiceProviderPerson1(val)
        },
        //获取施工员列表
        getServiceProviderPerson(id) {
            this.$http
                .request({
                    url: "/jjyl/admin/serviceProviderPersons/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        serviceProviderId: id,
                        dataId: this.datasid,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content == null || res.content == "null") {
                            this.providerPersonList = []
                            return
                        }
                        res.content.list.forEach((item) => {
                            item.id = String(item.id)
                        })
                        this.providerPersonList = res.content.list
                    }
                })
        },
        // 保留条件刷新
        Reset1() {
            this.getElderlyInfoList(true)
            this.tableChekbox = [
                "序号",
                "姓名",
                "性别",
                "联系方式",
                "身份证号",
                "年龄",
                "老人类型",
                "居住地址",
                "审核状态",
                "操作",
            ]
        },
        // 页面刷新
        Reset() {
            this.reload()
        },
        //获取施工员列表
        getServiceProviderPerson1(id) {
            let dataId = JSON.parse(localStorage.getItem("czUserInfo")).dataId
            this.$http
                .request({
                    url: "/jjyl/admin/serviceProviderPersons/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: 1000,
                        //    dataId:dataId
                        serviceProviderId: id,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content == null || res.content == "null") {
                            this.providerPersonList1 = []
                            return
                        }
                        // res.content.list.forEach((item) => {
                        //   item.id = String(item.id)
                        // })
                        this.providerPersonList1 = res.content.list
                    }
                })
        },
        vehicleRemove(index, title) {
            // console.log(index, title)
            this.vehicleVisible = true
            this.vehicleTitle = title
            this.vehicleList = index
        },
        vehicledelete(val, index) {
            this.vehicleList.splice(index, 1)
        },
        houseSuccess(res, file) {
            // console.log(res, file)
            this.imgforms.balconyPhotoShows.push(res.content)
        },
        houseSuccess1(res, file) {
            this.imgforms.balconyAfterPhotoShows.push(res.content)
        },
        houseSuccess2(res, file) {
            this.imgforms.bedroomPhotoShows.push(res.content)
        },
        houseSuccess3(res, file) {
            this.imgforms.bedroomAfterPhotoShows.push(res.content)
        },
        houseSuccess4(res, file) {
            this.imgforms.kitchenPhotoShows.push(res.content)
        },
        houseSuccess5(res, file) {
            this.imgforms.kitchenAfterPhotoShows.push(res.content)
        },
        houseSuccess6(res, file) {
            this.imgforms.livingRoomPhotoShows.push(res.content)
        },
        houseSuccess7(res, file) {
            this.imgforms.livingRoomAfterPhotoShows.push(res.content)
        },
        houseSuccess8(res, file) {
            this.imgforms.toiletPhotoShows.push(res.content)
        },
        houseSuccess9(res, file) {
            this.imgforms.toiletAfterPhotoShows.push(res.content)
        },
    },
    inject: ["reload"], //注入
    created() {
        this.baseUrl =
            baseURL + "/jjyl/controller/uploadController/info/uploadPhoto"
        //this.getProvince()
        this.getOrg()
        this.getElderlyInfoList()
        this.gettypeList()
        this.getProjectManage()
        this.getServiceProvider()
        this.getServiceProviderPerson1()
        this.getssOrg()
    },
    mounted() {},
}
</script>
<style>
.auto-item {
    font-size: 16px !important;
}
</style>
<style lang='less' scoped>
/deep/ .print_container {
    .el-checkbox__inner::after {
        content: none;
    }

    // .el-checkbox__input.is-checked+.el-checkbox__label {
    //   color: #606266;
    // }
    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: transparent;
        border-color: #000000;
    }
}

/deep/ .reference {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

/deep/ .reference_wrap {
    border-radius: 0;
}

.assessment_Form {
    /deep/ .inline_wrap_box {
        display: flex;
        flex-wrap: wrap;
        padding: 0 12px;
        text-align: left;

        .inline_wrapper {
            width: calc(100% / 3);
            box-sizing: border-box;
        }

        .inline_label {
            margin-right: 12px;
            width: 80px;
            display: inline-block;
        }

        .el-checkbox-group {
            display: inline-block;
        }

        .el-checkbox {
            margin-bottom: 8px;
        }
    }
}

/deep/ .total_wrapper {
    display: flex;
    border: 1px solid #ebeef5;
    border-top: none;

    span {
        color: #606266;
        line-height: 50px;
    }

    .total_title {
        width: 25%;
        text-align: center;
        border-right: 1px solid #ebeef5;
    }

    .total_count {
        flex: 1;
        text-align: center;
    }
}

.settlement_container {
    /deep/ .btn_group span {
        cursor: pointer;

        & + span {
            margin-left: 10px;
        }
    }

    /deep/ .dialog_content {
        position: relative;

        .fixed {
            position: absolute;
            right: 0;
            top: 60px;
            font-size: 24px;
            font-weight: bold;
            cursor: pointer;
        }

        .map_container {
            margin-top: 12px;
            display: flex;

            .map_left {
                box-sizing: border-box;
                margin-right: 10px;
                width: 260px;
                height: 300px;
                padding: 12px;
                overflow-y: auto;
                border: 1px solid #dcdfe6;
                border-radius: 5px;

                p {
                    line-height: 42px;
                    text-align: center;
                }
            }

            .map_right {
                width: 100%;
                height: 300px;
            }
        }

        .return_visit_form {
            .header {
                display: flex;
                justify-content: space-between;
                padding: 24px 0 36px;
            }
        }

        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }

        .avatar-uploader .el-upload:hover {
            border-color: #409eff;
        }

        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
        }

        .avatar {
            width: 178px;
            height: 178px;
            display: block;
        }

        .el-step__icon.is-text {
            border-radius: 5px;
        }

        .is-finish .el-step__icon {
            background: #409eff;
        }

        .el-step__icon {
            width: auto;
            padding: 15px 20px;
            color: #ffffff;
            cursor: pointer;
            border: none;
            background: #c0c4cc;
        }

        .el-step {
            height: 40px;
            margin-bottom: 24px;
        }

        .el-step.is-horizontal .el-step__line {
            top: 16px;
        }

        .dialog_content_pane {
            .el-tabs {
                padding-bottom: 50px;
                margin-bottom: 24px;
                border-bottom: 1px solid #ebeef5;
            }

            .dialog_form_left {
                .el-col:nth-child(n + 3) {
                    margin-top: 12px;
                }
            }

            .avatar_uploader {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                font-size: 28px;
                color: #8c939d;
                width: 178px;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                font-size: 28px;
                color: #8c939d;
                width: 178px;
                height: 178px;

                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }

            .assessment_upload {
                display: flex;
                justify-content: left;

                .avatar_uploader {
                    width: 100px;
                    height: 100px;
                    line-height: 100px;
                }

                .avatar {
                    width: 100px;
                    height: 100px;
                }

                .el-button {
                    width: 100px !important;
                }

                .el-col {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-top: 24px;
                }
            }

            .check_form_item,
            .acceptance_form_item {
                display: flex;
                flex-direction: column;

                .el-form-item__label {
                    width: 100% !important;
                    margin-bottom: 36px;
                    border-bottom: 1px solid #c0c4cc;
                    text-align: left;
                }

                .el-form-item__content {
                    margin-left: 0 !important;
                }

                .check_upload {
                    display: inline-block;

                    & + .check_upload {
                        margin-left: 40px;
                    }

                    .avatar_uploader {
                        width: 100px;
                        height: 100px;
                        line-height: 100px;
                    }

                    .avatar {
                        width: 100px;
                        height: 100px;
                    }

                    .el-button {
                        width: 100px !important;
                        margin-top: 0 !important;
                    }

                    .el-col {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                }
            }
        }
    }
}

.print_container {
    .print_title {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
    }

    .address_wrap {
        display: flex;
        justify-content: center;

        .item {
            position: relative;
            padding-left: 120px;
            margin-top: 24px;
            margin-bottom: 24px;

            & + .item {
                margin-left: 60px;
            }

            span {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 120px;
                border-bottom: 1px solid #000000;
                text-align: center;
            }
        }
    }

    .user_info {
        &:nth-child(4) {
            .inline_wrap {
                padding-bottom: 0;
                padding-top: 0;
            }
        }

        &:nth-child(6) {
            .content {
                padding-bottom: 0;
                padding-top: 0;
            }
        }

        .price_wrap {
            position: relative;
            padding-left: 120px;
            display: inline-block;

            span {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 120px;
                border-bottom: 1px solid #000000;
            }
        }

        .label {
            width: 120px;
        }

        .inline_title {
            text-align: left;
            text-indent: 12px;

            /deep/ .el-checkbox {
                margin-right: 0;
                text-indent: 0;
            }
        }

        .sign {
            padding: 12px;
            text-align: left;
        }

        .sign_ont {
            padding: 12px;
            text-align: left;
            padding-bottom: 60px;
        }

        .date {
            padding: 12px;
            text-align: right;

            span {
                margin-left: 30px;
            }
        }

        /deep/ .inline_wrap_box {
            display: flex;
            flex-wrap: wrap;
            padding: 12px;
            text-align: left;
            border-bottom: 1px solid #000000;
            margin-bottom: 22px;

            .inline_wrapper {
                width: calc(100% / 3);
                box-sizing: border-box;
            }

            .inline_label {
                margin-right: 12px;
                width: 80px;
                display: inline-block;
            }

            .el-checkbox-group {
                display: inline-block;
            }

            .el-checkbox {
                margin-bottom: 8px;
            }
        }

        /deep/ .inline_wrap {
            padding: 12px;
            text-align: left;

            .inline_label {
                margin-right: 12px;
            }

            .el-checkbox-group {
                display: inline-block;
            }

            .el-checkbox {
                margin-bottom: 8px;
            }
        }

        .inline_tips {
            line-height: 1.2;
            text-align: left;
            padding: 0 12px;
        }

        .inline_table {
            width: 100%;
            height: 100%;
            text-align: center;
            border-collapse: collapse;

            tr:first-child {
                td {
                    border-top: none;
                }
            }

            tr:last-child {
                td {
                    border-bottom: none;
                }
            }

            tr td {
                &:nth-child(1) {
                    border-left: none;
                }

                &:last-child {
                    border-right: none;
                }
            }

            .reform_wrap {
                padding: 0;

                p {
                    margin-bottom: 4px;
                }

                .reform_content_c {
                    display: flex;

                    span {
                        flex: 1;
                        text-align: center;
                        padding: 0 3px;
                    }
                }

                .reform_content {
                    display: flex;
                    padding-top: 12px;
                    border-top: 1px solid #000000;

                    span {
                        flex: 1;
                        text-align: center;
                        padding: 0 3px;
                    }
                }
            }
        }
    }

    .table_container,
    table tr th,
    table tr td {
        border: 1px solid #000000;
        padding: 24px 0;
    }

    .table_container {
        width: 100%;
        text-align: center;
        border-collapse: collapse;

        .inner-tr {
            &:first-child td {
                border-top: none;
            }

            &:last-child td {
                border-bottom: none;
            }

            td:nth-child(1) {
                border-left: none;
            }

            td:last-child {
                border-right: none;
            }
        }
    }
}

.button-group {
    position: absolute;
    bottom: 20px;
    right: 20px;
    font-size: 12px;
    padding: 10px;
}

.button-group .button {
    height: 28px;
    line-height: 28px;
    background-color: #0d9bf2;
    color: #fff;
    border: 0;
    outline: none;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 3px;
    margin-bottom: 4px;
    cursor: pointer;
}

.button-group .inputtext {
    height: 26px;
    line-height: 26px;
    border: 1px;
    outline: none;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 3px;
    margin-bottom: 4px;
    cursor: pointer;
}

.amap-info-content {
    font-size: 12px;
}

#myPageTop {
    position: absolute;
    top: 5px;
    right: 10px;
    background: #fff none repeat scroll 0 0;
    // border: 1px solid #ccc;
    margin: 10px auto;
    padding: 6px;
    font-size: 14px;
}

#myPageTop label {
    margin: 0 20px 0 0;
    color: #666666;
    font-weight: normal;
}

#myPageTop input {
    width: 170px;
}

#myPageTop .column2 {
    padding-left: 25px;
}

.amap-sug-result {
    z-index: 1020000004 !important;
    left: 30%;
}
.pictreus {
    /deep/.el-upload--picture-card {
        width: 100px;
        height: 40px;
        line-height: 40px;
    }
    width: 100px;
    height: 40px;
    line-height: 40px;
}
.maskIcons {
    position: absolute;
    left: 57px;
    top: 55px;
    //   background: rgba(0, 0, 0, 0);
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    .biget,
    .imgdel {
        opacity: 0;
    }
}
.maskIcons:hover {
    background: rgba(0, 0, 0, 0.5);
    .biget,
    .imgdel {
        opacity: 1;
    }
}
.biget,
.imgdel {
    color: #fff;
    font-size: 20px;
}
.imgdel {
    //   margin-left: 0px;
}
// .is-disabled {
//   background-color: #F5F7FA;
// }
.vehiclecal {
    position: relative;
    .maskIcons {
        position: absolute;
        left: 0px;
        top: 0px;
        // background: rgba(36, 36, 36, 0.493);
        width: 120px;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        .biget,
        .imgdel {
            opacity: 0;
        }
    }
    .maskIcons:hover {
        background: rgba(36, 36, 36, 0.493);
        .biget,
        .imgdel {
            opacity: 1;
        }
    }
    .biget,
    .imgdel {
        color: #fff;
        font-size: 20px;
    }
    .imgdel {
        margin-left: 20px;
    }
}
.showImg {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 9999;
    display: flex;
    justify-content: space-around;
    align-items: center;
    &::before {
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        content: "";
        opacity: 0.5;
        background: #000;
    }
    .close {
        position: absolute;
        right: 20px;
        top: 20px;
        background: #fff;
        width: 50px;
        height: 50px;
        border-radius: 100%;
        text-align: center;
        font-size: 30px;
        line-height: 50px;
        cursor: pointer;
    }
    .img {
        max-width: 600px;
        height: auto;
        img {
            width: auto;
            height: auto;
        }
    }
    .pre {
        background: #fff;
        width: 50px;
        height: 50px;
        border-radius: 100%;
        text-align: center;
        font-size: 35px;
        line-height: 50px;
        cursor: pointer;
    }
    .next {
        background: #fff;
        width: 50px;
        height: 50px;
        border-radius: 100%;
        text-align: center;
        font-size: 35px;
        line-height: 46px;
        cursor: pointer;
    }
    .tebIndex {
        position: absolute;
        left: 0;
        right: 0;
        top: 20px;
        margin: 0 auto;
        width: 100px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 15px;
        font-size: 18px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
    }
    .delImg {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 20px;
        background: #fff;
        width: 50px;
        height: 50px;
        border-radius: 100%;
        text-align: center;
        font-size: 30px;
        line-height: 46px;
        cursor: pointer;
    }
}
.el-badge {
    width: 100px;
    height: 114px;
}
/deep/ .el-badge__content--primary {
    position: absolute;
    right: 5px;
    top: 5px;
}
</style>

